// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      "Current Total Due": "Current Total Due",
      "Current Total Due (TZS)": "Current Total Due (TZS)",
      "Outstanding Base": "Outstanding Base",
      "Current SSC": "Current SSC",
      "Current Bank Charge": "Current Bank Charge",
      "Base Allocated": "Base Allocated",
      "Original Base": "Original Base",
      "Original SSC": "Original SSC",
      "Original Total": "Original Total",
      "Paid: {{date}}": "Paid: {{date}}",
      // legacy keys referenced throughout the app
      welcome: "Welcome",
      Dashboard: "Dashboard",
      users: "Users",
      settings: "Settings",
      logout: "Logout",
      addUser: "Add User",
      members: "Members",
      contributions: "Contributions",
      loans: "Loans",
      language: "Language",
      "Manage the system and oversee all groups": "Manage the system and oversee all groups",
      "Group Contributions": "Group Contributions",
      "Group Management": "Group Management",
      "Desk Officer Dashboard": "Desk Officer Dashboard",
      "Member Dashboard": "Member Dashboard",
      "Admin Dashboard": "Admin Dashboard",
      "Accountant Dashboard": "Accountant Dashboard",
      "Chairperson Dashboard": "Chairperson Dashboard",
      "Loan Management": "Loan Management",
      'ALL LOANS': 'ALL LOANS',
      "MY LOANS": "MY LOANS",
      "ALL STATUS": "ALL STATUS",
      "ACTIVE": "ACTIVE",
      "PENDING": "PENDING",
      "Search loan or member": "Search loan or member",
      "APPLY LOAN": "APPLY LOAN",
      "Total Groups": "Total Groups",
      "Total Members": "Total Members",
      "New Groups (This Month)": "New Groups (This Month)",
      "Total Transactions (This Month)": "Total Transactions (This Month)",
      "Loan Disbursement vs Contributions (trend)": "Loan Disbursement vs Contributions (trend)",
      "Loan Disbursements": "Loan Disbursements",
      "Disbursements": "Disbursements",
      "Quick Actions": "Quick Actions",
      "User Management": "User Management",
      "System Reports": "System Reports",
      "View Audit Logs": "View Audit Logs",
      "Recent Group Registrations": "Recent Group Registrations",
      // General Report
      "Generate Report": "Generate Report",
      "Report Summary": "Report Summary",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "Branch": "Branch",
      "All Branches": "All Branches",
      "Total Insurance Amount": "Total Insurance Amount",
      "Total Registration Payment": "Total Registration Payment",
      "Total Visiting Payment": "Total Visiting Payment",
      "Total Penalties": "Total Penalties",
      "Total Expenses": "Total Expenses",
      "Total Loans Disbursed": "Total Loans Disbursed",
      "Total Collections": "Total Collections",
      "Total Repayments": "Total Repayments",
      "Exceeded Amount": "Exceeded Amount",
      "Start date is required": "Start date is required",
      "End date is required": "End date is required",
      // Loan Report
      "Loans Report": "Loans Report",
      "Search loan or member": "Search loan or member",
      "Are you sure you want to Approve this Loan?": "Are you sure you want to Approve this Loan?",
      "Loan successfully approved": "Loan successfully approved",
      "Unauthorized": "Unauthorized",
      "You are not authorized to approve loans": "You are not authorized to approve loans",
      "Customer": "Customer",
      "Category": "Category",
      "Amount": "Amount",
      "Repayment": "Repayment",
      "StartDate": "StartDate",
      "EndDate": "EndDate",
      "Action": "Action",
      "Full paid": "Full paid",
      "Not paid at all": "Not paid at all",
      "Under paid": "Under paid",
      "Repayments": "Repayments",
      "Repayments schedule": "Repayments schedule",
      "Schedule": "Schedule",
      "Network Problem.Please check your Internet": "Network Problem.Please check your Internet",
      "Previous": "Previous",
      "Next": "Next",
      // Reportes
      "Financial Reports": "Financial Reports",
      "Income Statement": "Income Statement",
      "Profit/Loss Trend": "Profit/Loss Trend",
      "Type": "Type",
      "Interval": "Interval",
      "Income statement": "Income statement",
      "daily": "daily",
      "Quarterly": "Quarterly",
      "Yearly": "Yearly",
      "From": "From",
      "To": "To",
      "GENERATE": "GENERATE",
      "ITEM": "ITEM",
      "AMOUNT": "AMOUNT",
      "Purchases": "Purchases",
      "Returned Purchases": "Returned Purchases",
      "Sales": "Sales",
      "Returned Sales": "Returned Sales",
      "Expenses": "Expenses",
      "Wastages": "Wastages",
      "Profit/Loss": "Profit/Loss",
      // Reports Pages
      "From": "From",
      "To": "To",
      "Group": "Group",
      "Loading groups...": "Loading groups...",
      "Error loading groups": "Error loading groups",
      "No groups found": "No groups found",
      "Member": "Member",
      "Loading members...": "Loading members...",
      "Error loading members": "Error loading members",
      "Select a group first": "Select a group first",
      "Generate": "Generate",
      "Generating...": "Generating...",
      "Export as PDF": "Export as PDF",
      "Export as Excel": "Export as Excel",
      "Failed to load groups.": "Failed to load groups.",
      "Failed to load members.": "Failed to load members.",
      // AuditComplianceReport
      "Audit & Compliance Report": "Audit & Compliance Report",
      "Trace all system actions for regulatory and internal audit requirements.": "Trace all system actions for regulatory and internal audit requirements.",
      "Access: Admin only (or as per policy)": "Access: Admin only (or as per policy)",
      "Audit Trail": "Audit Trail",
      "Date & Time": "Date & Time",
      "User": "User",
      "Details": "Details",
      "No matching audit events for the selected filters.": "No matching audit events for the selected filters.",
      "Loading report...": "Loading report...",
      "Please select filters and click \"Generate\" to view the report.": "Please select filters and click \"Generate\" to view the report.",
      "User / Action Search": "User / Action Search",
      "Export logic not yet implemented.": "Export logic not yet implemented.",
      "Info": "Info",
      // GroupLiquidityReport
      "Group Liquidity Position": "Group Liquidity Position",
      "Cash availability versus outstanding loan obligations.": "Cash availability versus outstanding loan obligations.",
      "Access: Chairperson / Secretary / Accountant / Admin / Desk Officer": "Access: Chairperson / Secretary / Accountant / Admin / Desk Officer",
      "Cash on Hand": "Cash on Hand",
      "Group Bank Balance": "Group Bank Balance",
      "Liquidity Index": "Liquidity Index",
      "Higher is better. Below 50% is a risk signal.": "Higher is better. Below 50% is a risk signal.",
      "Obligations vs Available Cash": "Obligations vs Available Cash",
      "Obligations": "Obligations",
      "Outstanding Loans": "Outstanding Loans",
      "Overdue Loans": "Overdue Loans",
      "Expected Repayments (month)": "Expected Repayments (month)",
      "Simple Liquidity Visual": "Simple Liquidity Visual",
      "Integrate a proper chart (e.g. Recharts) later.": "Integrate a proper chart (e.g. Recharts) later.",
      "Please select a group and click \"Generate\" to view the report.": "Please select a group and click \"Generate\" to view the report.",
      "Please select a group to generate the report.": "Please select a group to generate the report.",
      "Missing Filter": "Missing Filter",
      // MemberHealthScoreReport
      "Member Financial Health Score": "Member Financial Health Score",
      "Risk and reliability score per member based on repayments, arrears and penalties.": "Risk and reliability score per member based on repayments, arrears and penalties.",
      "Financial Health Overview": "Financial Health Overview",
      "Score derived from repayment history, arrears, contribution consistency, penalties and defaults.": "Score derived from repayment history, arrears, contribution consistency, penalties and defaults.",
      "Select a group to see all members, or select a specific member, then click \"Generate\".": "Select a group to see all members, or select a specific member, then click \"Generate\".",
      "Score": "Score",
      "Arrears": "Arrears",
      "Penalties": "Penalties",
      "No health score data available for the selected member.": "No health score data available for the selected member.",
      "Excellent": "Excellent",
      "Good": "Good",
      "Fair": "Fair",
      // MonthlyGroupPerformanceReport
      "Monthly Group Performance": "Monthly Group Performance",
      "Summary of contributions, loans, penalties and balances for the selected period.": "Summary of contributions, loans, penalties and balances for the selected period.",
      "Missing Filters": "Missing Filters",
      "Please select a group and a date range to generate the report.": "Please select a group and a date range to generate the report.",
      "No Data": "No Data",
      "Please generate a report first before exporting.": "Please generate a report first before exporting.",
      "Export Failed": "Export Failed",
      "Total Contributions": "Total Contributions",
      "Total Income (Period)": "Total Income (Period)",
      "Loan Disbursements": "Loan Disbursements",
      "Group Balance": "Group Balance",
      "Member Level Performance": "Member Level Performance",
      "Per-member summary for this period.": "Per-member summary for this period.",
      "Active": "Active",
      "Inactive": "Inactive",
      "Loans Disbursed": "Loans Disbursed",
      // SystemGrowthMetricsReport
      "System Growth Metrics": "System Growth Metrics",
      "High level performance across all groups in the system.": "High level performance across all groups in the system.",
      "Access: Admin / Desk Officer only": "Access: Admin / Desk Officer only",
      "New Members": "New Members",
      "Member Exits": "Member Exits",
      "Loans Issued": "Loans Issued",
      "Loans Repaid": "Loans Repaid",
      "New Groups": "New Groups",
      "Business Invoices": "Business Invoices",
      "Visual Overview (Mock)": "Visual Overview (Mock)",
      "Replace with real chart component later (Recharts/Chart.js)": "Replace with real chart component later (Recharts/Chart.js)",
      "max scale": "max scale",
      "Donations": "Donations",
      "Groups": "Groups",
      // LoanReportDialog & ReportPopup
      "Upload Contract": "Upload Contract",
      "Use Description": "Use Description",
      "Use Expire Date": "Use Expire Date",
      "Use Bacth Number": "Use Bacth Number",
      "Use Category": "Use Category",
      "Loan Category": "Loan Category",
      "Repayment Method": "Repayment Method",
      "Duration": "Duration",
      "Interest rate %": "Interest rate %",
      "Start date": "Start date",
      "Entrepreneur": "Entrepreneur",
      "Business": "Business",
      "Workers": "Workers",
      "Daily": "Daily",
      "Monthly": "Monthly",
      "Loan successful updated": "Loan successful updated",
      "Product added": "Product added",
      "Product successful updated": "Product successful updated",
      "Product settings successful updated": "Product settings successful updated",
      "Product successful deleted": "Product successful deleted",
      "Something went wrong": "Something went wrong",
      "Patient successful sent to Dr": "Patient successful sent to Dr",
      "Please select Dr": "Please select Dr",
      "Please fill in the required fields": "Please fill in the required fields",
      "Error occured": "Error occured",
      "BILLING INFO": "BILLING INFO",
      "Purchases Total": "Purchases Total",
      "Returned Purchases Total": "Returned Purchases Total",
      "Sales Total": "Sales Total",
      "Returned Sales Total": "Returned Sales Total",
      "Expenses Total": "Expenses Total",
      "Associated Costs Total": "Associated Costs Total",
      "Quantity": "Quantity",
      "Gender": "Gender",
      "Phone": "Phone",
      "RETURN": "RETURN",
      "Report successful generated": "Report successful generated",
      "Sale successful returned": "Sale successful returned",
      "Sale successful deleted": "Sale successful deleted",
      // User Profile
      "Waiting for Chairperson": "Waiting for Chairperson",
      "Waiting for Secretary": "Waiting for Secretary",
      "Waiting for Accountant": "Waiting for Accountant",
      "Completed": "Completed",
      "Rejected": "Rejected",
      "Chairperson": "Chairperson",
      "Secretary": "Secretary",
      "Accountant": "Accountant",
      "Current password is required": "Current password is required",
      "New password is required": "New password is required",
      "Passwords do not match": "Passwords do not match",
      "Password successfully updated": "Password successfully updated",
      "New Password Error": "New Password Error",
      "Current Password Error": "Current Password Error",
      "My Savvy Community Profile": "My Savvy Community Profile",
      "Next of Kin (Heir)": "Next of Kin (Heir)",
      "Relationship": "Relationship",
      "Heir information not set. Please contact your group administrator.": "Heir information not set. Please contact your group administrator.",
      "Membership Withdrawal Workflow": "Membership Withdrawal Workflow",
      "Requests flow through Chairperson → Secretary → Accountant. Financial clearance is verified automatically before payout.": "Requests flow through Chairperson → Secretary → Accountant. Financial clearance is verified automatically before payout.",
      "You already have a withdrawal request in progress.": "You already have a withdrawal request in progress.",
      "Start a new withdrawal request": "Start a new withdrawal request",
      "Financial clearance": "Financial clearance",
      "You currently have no outstanding obligations.": "You currently have no outstanding obligations.",
      "Please clear the following outstanding amounts before the request reaches the accountant:": "Please clear the following outstanding amounts before the request reaches the accountant:",
      "Pending contributions": "Pending contributions",
      "Retention percentage": "Retention percentage",
      "of your current savings": "of your current savings",
      "remains with the group per policy": "remains with the group per policy",
      "Request submitted": "Request submitted",
      "Group leadership will now review your withdrawal request.": "Group leadership will now review your withdrawal request.",
      "Request details": "Request details",
      "Your request was rejected. Please talk to the leadership team for the next steps.": "Your request was rejected. Please talk to the leadership team for the next steps.",
      "Your request is moving through the approval chain.": "Your request is moving through the approval chain.",
      "Reason for withdrawal": "Reason for withdrawal",
      "Rejection details": "Rejection details",
      "Retention breakdown": "Retention breakdown",
      "Amount retained by the group": "Amount retained by the group",
      "Refund issued to you": "Refund issued to you",
      "Finalized on": "Finalized on",
      "Not approved yet": "Not approved yet",
      "Use the arrow icon above to submit a withdrawal request once you are confident about the figures shown here.": "Use the arrow icon above to submit a withdrawal request once you are confident about the figures shown here.",
      "Security": "Security",
      "Current Password": "Current Password",
      "New Password": "New Password",
      "Confirm New Password": "Confirm New Password",
      "Update Password": "Update Password",
      "Submit Withdrawal Request": "Submit Withdrawal Request",
      "Share the reason you want to leave the group. Your explanation will be visible to the leadership team reviewing the request.": "Share the reason you want to leave the group. Your explanation will be visible to the leadership team reviewing the request.",
      "Explain briefly why you want to withdraw...": "Explain briefly why you want to withdraw...",
      "Once the Chairperson and Secretary approve, the system re-checks loans, penalties, and contributions before the Accountant releases the final payout.": "Once the Chairperson and Secretary approve, the system re-checks loans, penalties, and contributions before the Accountant releases the final payout.",
      "Unable to submit your request right now.": "Unable to submit your request right now.",
      "Please provide a brief reason for leaving.": "Please provide a brief reason for leaving.",
      "View All": "View All",
      "Chair": "Chair",
      "Members": "Members",
      "Status": "Status",
      "Pending Approvals": "Pending Approvals",
      "Approved Groups": "Approved Groups",
      "No recent group registrations found.": "No recent group registrations found.",
      "Loading dashboard data...": "Loading dashboard data...",
      "Failed to load dashboard: {{error}}": "Failed to load dashboard: {{error}}",
      "Failed to load data": "Failed to load data",
      "Register groups, manage approvals, and keep leaders informed": "Register groups, manage approvals, and keep leaders informed",
      "Group Registration Trend (Last 6 Months)": "Group Registration Trend (Last 6 Months)",
      "No transaction data available for the selected period.": "No transaction data available for the selected period.",
      "Review Pending Approvals": "Review Pending Approvals",
      "Generate Registration Link": "Generate Registration Link",
      "Frequency": "Frequency",
      "Chairperson": "Chairperson",
      "N/A": "N/A",
      "Approved": "Approved",
      "Pending": "Pending",
      "Unable to load dashboard data": "Unable to load dashboard data",
      "© {year} Savvy Community": "© {year} Savvy Community",
      "just now": "just now",
      "{{count}} seconds ago": "{{count}} seconds ago",
      "{{count}} minutes ago": "{{count}} minutes ago",
      "{{count}} hours ago": "{{count}} hours ago",
      "{{count}} days ago": "{{count}} days ago",
      "Weekly Contributions (TZS, in K)": "Weekly Contributions (TZS, in K)",
      "Last 6 weeks": "Last 6 weeks",
      "Up to date": "Up to date",
      "Not enough transaction data yet.": "Not enough transaction data yet.",
      "View Group Summary": "View Group Summary",
      "Approve Loan": "Approve Loan",
      "Recent Member Contributions (Last 5)": "Recent Member Contributions (Last 5)",
      "Operation Fee (OF)": "System Service Charge (SSC)",
      "System Service Charge (SSC)": "System Service Charge (SSC)",
      "System Service Charge (SSC):": "System Service Charge (SSC):",
      "No contributions recorded yet.": "No contributions recorded yet.",
      "Your Group": "Your Group",
      "Next Contribution": "Next Contribution",
      "TBD": "TBD",
      "Active Members": "Active Members",
      "Current Balance (TZS)": "Current Balance (TZS)",
      "Pending Loans": "Pending Loans",
      "No active membership found.": "No active membership found.",
      "Track your savings, loans, and performance": "Track your savings, loans, and performance",
      "Total Contributions (TZS)": "Total Contributions (TZS)",
      "Loan Balance (TZS)": "Loan Balance (TZS)",
      "Penalties (TZS)": "Penalties (TZS)",
      "Dividends (TZS)": "Dividends (TZS)",
      "My Weekly Contributions (TZS, in K)": "My Weekly Contributions (TZS, in K)",
      "Last 5 weeks — contributions vs captured disbursements": "Last 5 weeks — contributions vs captured disbursements",
      "Live data": "Live data",
      "Make Contribution": "Make Contribution",
      "View My Statement": "View My Statement",
      "Request Loan": "Request Loan",
      "Upcoming Deadlines & Reminders": "Upcoming Deadlines & Reminders",
      "No upcoming reminders at the moment.": "No upcoming reminders at the moment.",
      "Recent Transactions": "Recent Transactions",

      common: {
        changeLanguage: "Change language",
        english: "English",
        swahili: "Swahili",
      },
      login: {
        heroLabel: "Savvy Community",
        heroHeadline: "Banking-grade tools for modern Savvy Community teams",
        heroBody:
          "Keep contributions, penalties, loans, and statements synced in real time with transparency members can trust.",
        heroPoints: [
          "Realtime dashboards",
          "Automated compliance logs",
          "Member-first notifications",
        ],
        greeting: "Welcome back to Savvy Community",
        subtitle: "Sign in to keep your group's finances moving smoothly.",
      },
      layout: {
        notificationsTitle: "Notifications",
        noNotifications: "No new notifications",
        adminSection: "Admin",
        workflowsSection: "Workflows",
        coreSection: "Core",
        reportsSection: "Reports",
        profile: "My Profile",
        logout: "Logout",
        systemName: "Savvy Community",
        groupLabel: "Group",
        noGroup: "No group assigned",
      },
      nav: {
        adminDashboard: "Admin Dashboard",
        userManagementAdmin: "User Management (Admin)",
        migrationStudio: "Group Migration",
        settings: "Settings",
        adminSettings: "Settings",
        adminReconciliation: "Reconciliation",
        chairpersonSettings: "Group Settings",
        deskOfficerDashboard: "Desk Officer Dashboard",
        chairpersonDashboard: "Chairperson Dashboard",
        katibuDashboard: "Katibu Dashboard",
        accountantDashboard: "Muhasibu Dashboard",
        memberDashboard: "Member Dashboard",
        loans: "Loans",
        groupsDeskOfficer: "Groups",
        membersChairperson: "Members",
        contributionsMember: "Contributions",
        catchupPayments: "My Catch-up Payments",
        catchupPaymentsChair: "Manage Catch-up Payments",
        emergencyChair: "Emergency Contributions",
        emergencyMember: "Emergency Contributions",
        groupBusinessesChair: "Group Businesses",
        groupBusinessesAdmin: "Group Businesses",
        specialContributionsMember: "Special Contributions",
        dividendsMember: "Dividends",
        dividendsChair: "Dividends",
        financeTransactions: "Finance Transactions",
        upatuDisbursements: "Upatu Disbursements",
        memberWithdrawalApprovals: "Member Withdrawal Approvals",
        switchGroup: "Switch Group",
        loanReport: "Loan Report",
        repayments: "Repayments",
        generalReport: "General Report",
        monthlyGroupPerformance: "Monthly Group Performance",
        memberHealthScore: "Member Financial Health",
        groupLiquidity: "Group Liquidity",
        systemGrowthMetrics: "System Growth Metrics",
        auditCompliance: "Audit & Compliance",
        expenses: "Expenses",
      },
      "Error: {{message}}": "Error: {{message}}",
      "My Emergency Contributions": "My Emergency Contributions",
      "View all emergency deductions and pending invoices.": "View all emergency deductions and pending invoices.",
      "Emergency Deductions": "Emergency Deductions",
      "Emergency Invoices": "Emergency Invoices",
      "Search event name or reference...": "Search event name or reference...",
      "Deduction Type": "Deduction Type",
      "Event": "Event",
      "Event Name": "Event Name",
      "Event Deduction": "Event Deduction",
      "Deduction": "Deduction",
      "From Overpayment": "From Overpayment",
      "From Balance": "From Balance",
      "From Main Balance": "From Main Balance",
      "From": "From",
      "To": "To",
      "Date": "Date",
      "Amount Due": "Amount Due",
      "Your Debt": "Your Debt",
      "DF Amount": "SSC Amount",
      "DF Amount:": "SSC Amount:",
      "SSC Amount": "SSC Amount",
      "SSC Amount:": "SSC Amount:",
      "Total To Pay": "Total To Pay",
      "Reference": "Reference",
      "Issued At": "Issued At",
      "No emergency deductions found.": "No emergency deductions found.",
      "No invoices.": "No invoices.",
      "Reset filters": "Reset filters",
      "All": "All",
      // Group Businesses page
      "Group Businesses": "Group Businesses",
      "Register, approve, and manage group-owned business income.": "Register, approve, and manage group-owned business income.",
      "Active Businesses": "Active Businesses",
      "Pending Admin Approval": "Pending Admin Approval",
      "Pending Invoices": "Pending Invoices",
      "Total Business Income": "Total Business Income",
      "Business Overview": "Business Overview",
      "Register New Business": "Register New Business",
      "Business List": "Business List",
      "Invoices For My Action": "Invoices For My Action",
      "Business": "Business",
      "Business Name": "Business Name",
      "Business Type": "Business Type",
      "Register Group Business": "Register Group Business",
      "Active": "Active",
      "Pending Admin": "Pending Admin",
      "Rejected": "Rejected",
      "Created": "Created",
      "View Details": "View Details",
      "Approve Business": "Approve Business",
      "No businesses registered yet.": "No businesses registered yet.",
      "My Action": "My Action",
      "Download": "Download",
      "Approve": "Approve",
      "Pending": "Pending",
      "Payment Ref": "Payment Ref",
      "Customer": "Customer",
      "Contact": "Contact",
      "Items": "Items",
      "Subtotal": "Subtotal",
      "Amount To Pay": "Amount To Pay",
      "Paid": "Paid",
      "Payment Status": "Payment Status",
      "Chain": "Chain",
      "No invoices found.": "No invoices found.",
      "Unknown Business": "Unknown Business",
      "Download Invoice PDF": "Download Invoice PDF",
      "Pending approvals": "Pending approvals",
      "Action": "Action",
      "By": "By",
      "At": "At",
      "Invoices": "Invoices",
      "Audit Trail": "Audit Trail",
      "New Invoice": "New Invoice",
      "No invoices yet.": "No invoices yet.",
      "Item count label": "{{count}} item(s)",
      "Line Items": "Line Items",
      "Add Item": "Add Item",
      "Item {{index}} Description": "Item {{index}} Description",
      "Quantity": "Quantity",
      "Unit Price (TZS)": "Unit Price (TZS)",
      "Line Total": "Line Total",
      "Remove item": "Remove item",
      "Service Amount (TZS)": "Service Amount (TZS)",
      "Sum of all line item totals": "Sum of all line item totals",
      "Invoice Payment Reference": "Invoice Payment Reference",
      "Copy reference": "Copy reference",
      "Share this reference with customers at the bank to ensure matching payments.": "Share this reference with customers at the bank to ensure matching payments.",
      "Summary": "Summary",
      "Payment Reference: {{ref}}": "Payment Reference: {{ref}}",
      "Summary line": "{{index}}. {{description}} — {{quantity}} × {{unit}} TZS = {{total}} TZS",
      "Summary totals": "Subtotal: {{subtotal}} TZS | SSC ({{percent}}%): {{fee}} TZS | Total: {{total}} TZS",
      "Special note: OF is retained automatically. Customer should pay the total amount shown above.": "Special note: SSC is retained automatically. Customer should pay the total amount shown above.",
      "Special note: SSC is retained automatically. Customer should pay the total amount shown above.": "Special note: SSC is retained automatically. Customer should pay the total amount shown above.",
      "Muhasibu approval note": "Muhasibu approval no longer credits funds automatically—credit happens at the bank and the system only reflects cash once the customer's payment is captured.",
      "Send for Approval": "Send for Approval",
      "{{name}} — Details": "{{name}} — Details",
      "Total Income": "Total Income",
      "Customer Name": "Customer Name",
      "Customer Phone": "Customer Phone",
      "Customer Address": "Customer Address",
      "Invoice Date": "Invoice Date",
      "Description (Service Rendered)": "Description (Service Rendered)",
      "Service": "Service",
      "Rental": "Rental",
      "Product Sales": "Product Sales",
      "Other": "Other",
      "Starting Capital (TZS)": "Starting Capital (TZS)",
      "Submit (Admin Approval)": "Submit (Admin Approval)",
      "Reference copied": "Reference copied",
      "Copy failed": "Copy failed",
      "Please copy the reference manually.": "Please copy the reference manually.",
      "Copy not supported": "Copy not supported",
      "Select and copy the reference manually.": "Select and copy the reference manually.",
      "Customer name is required": "Customer name is required",
      "Customer phone is required": "Customer phone is required",
      "Customer address is required": "Customer address is required",
      "Description is required": "Description is required",
      "Quantity must be greater than 0": "Quantity must be greater than 0",
      "Unit price must be greater than 0": "Unit price must be greater than 0",
      "Add at least one valid line item.": "Add at least one valid line item.",
      "Please fix the highlighted line items.": "Please fix the highlighted line items.",
      "Please fix the highlighted fields.": "Please fix the highlighted fields.",
      "Create Invoice — {{name}}": "Create Invoice — {{name}}",
      "No line items captured.": "No line items captured.",
      "Item": "Item",
      "Line item tooltip": "{{index}}. {{description}} ({{quantity}} × {{unit}} TZS = {{total}} TZS)",
      "Payment due label": "{{label}} ({{amount}} TZS due)",
      "Pending Katibu": "Pending Katibu",
      "Pending Muhasibu": "Pending Muhasibu",
      "Approved (bank capture pending)": "Approved (bank capture pending)",
      "Draft": "Draft",
      "Awaiting approval": "Awaiting approval",
      "Awaiting payment": "Awaiting payment",
      "Partially paid": "Partially paid",
      "Overdue": "Overdue",
      "Paid in full": "Paid in full",
      "Awaiting payment data": "Awaiting payment data",
      "Chair ✓ → Katibu": "Chair ✓ → Katibu",
      "Katibu ✓ → Muhasibu": "Katibu ✓ → Muhasibu",
      "Muhasibu ✓ (Approved, await bank credit)": "Muhasibu ✓ (Approved, await bank credit)",
      "Submitted for Admin approval": "Submitted for Admin approval",
      "Registration Failed": "Registration Failed",
      "Invoice sent to Katibu": "Invoice sent to Katibu",
      "Invoice Creation Failed": "Invoice Creation Failed",
      "Approve Business?": "Approve Business?",
      "Activate \"{{name}}\"": "Activate \"{{name}}\"",
      "Business approved": "Business approved",
      "Approval Failed": "Approval Failed",
      "Approved → Muhasibu": "Approved → Muhasibu",
      "Approved (awaiting bank payment capture)": "Approved (awaiting bank payment capture)",
      "Download Failed": "Download Failed",
      // Special Contribution Programs
      "Special Contribution Programs": "Special Contribution Programs",
      "Monitor program progress, member payments, and handle withdrawals with proper approval chain.": "Monitor program progress, member payments, and handle withdrawals with proper approval chain.",
      "All Programs": "All Programs",
      "My Programs": "My Programs",
      "Search program or leader...": "Search program or leader...",
      "Start Program": "Start Program",
      "Total Programs": "Total Programs",
      "Active Programs": "Active Programs",
      "Closed & Ready for Withdrawal": "Closed & Ready for Withdrawal",
      "Programs": "Programs",
      "Program": "Program",
      "Leader": "Leader",
      "Progress": "Progress",
      "Status based on target amount & timeframe closure.": "Status based on target amount & timeframe closure.",
      "No programs found.": "No programs found.",
      "Closed (Target Reached)": "Closed (Target Reached)",
      "Closed (Time Ended)": "Closed (Time Ended)",
      "Pending Chair Approval": "Pending Chair Approval",
      "Pending Secretary Approval": "Pending Secretary Approval",
      "Pending Accountant Approval": "Pending Accountant Approval",
      "Not Requested": "Not Requested",
      "Funds Released": "Funds Released",
      "Withdrawal Rejected": "Withdrawal Rejected",
      "Failed to load programs": "Failed to load programs",
      "Could not load members": "Could not load members",
      "Initiator inactive": "Initiator inactive",
      "Only active members can initiate a program.": "Only active members can initiate a program.",
      "Missing Title": "Missing Title",
      "Please enter a program title.": "Please enter a program title.",
      "Invalid Target": "Invalid Target",
      "Target per member must be greater than zero.": "Target per member must be greater than zero.",
      "Missing Dates": "Missing Dates",
      "Please select start and end dates.": "Please select start and end dates.",
      "Invalid Timeframe": "Invalid Timeframe",
      "End date must be after start date.": "End date must be after start date.",
      "No Participants": "No Participants",
      "Select at least one active participant.": "Select at least one active participant.",
      "Creation Failed": "Creation Failed",
      "Program Created": "Program Created",
      "Title:": "Title:",
      "Leader:": "Leader:",
      "Participants (active):": "Participants (active):",
      "Target/Member:": "Target/Member:",
      "Total Target:": "Total Target:",
      "Program now pending approval from the Chairperson.": "Program now pending approval from the Chairperson.",
      "Program still active": "Program still active",
      "Withdrawal can only be initiated after the program closes.": "Withdrawal can only be initiated after the program closes.",
      "Request Already Exists": "Request Already Exists",
      "Withdrawal request exists status": "A withdrawal request for this program already exists with status: {{status}}.",
      "Request Withdrawal?": "Request Withdrawal?",
      "Enter beneficiary details for the withdrawable amount of {{amount}} TZS.": "Enter beneficiary details for the withdrawable amount of {{amount}} TZS.",
      "Beneficiary Name": "Beneficiary Name",
      "Beneficiary Account (Bank/Mobile)": "Beneficiary Account (Bank/Mobile)",
      "Purpose of withdrawal (optional)": "Purpose of withdrawal (optional)",
      "Submit Request": "Submit Request",
      "Beneficiary name and account are required.": "Beneficiary name and account are required.",
      "Withdrawal Request Sent!": "Withdrawal Request Sent!",
      "Withdrawal pending chairperson": "The request is now pending approval from the Chairperson.",
      "Request Failed": "Request Failed",
      "Status:": "Status:",
      // Member Dividends
      "My Dividends": "My Dividends",
      "Track your personal dividend receipts with bank-grade transparency.": "Track your personal dividend receipts with bank-grade transparency.",
      "Refresh": "Refresh",
      "Total dividends received": "Total dividends received",
      "Last distribution": "Last distribution",
      "Largest single payout": "Largest single payout",
      "Pending": "Pending",
      "Payout History": "Payout History",
      "Search description or period...": "Search description or period...",
      "From": "From",
      "To": "To",
      "Target Type": "Target Type",
      "All Runs": "All Runs",
      "Active Members": "Active Members",
      "Borrowers": "Borrowers",
      "Period": "Period",
      "Target": "Target",
      "Description": "Description",
      "Amount": "Amount",
      "Dividend distribution": "Dividend distribution",
      "Posted on {{date}}": "Posted on {{date}}",
      "Latest Activity": "Latest Activity",
      "Credited on {{date}}": "Credited on {{date}}",
      "No dividend payouts yet": "No dividend payouts yet",
      "Your dividend earnings will appear here right after the next group distribution.": "Your dividend earnings will appear here right after the next group distribution.",
      // Transactions Audit
      "Transactions & Audit": "Transactions & Audit",
      "Unified financial view — Member Statements & Program Audit Logs": "Unified financial view — Member Statements & Program Audit Logs",
      "Retry": "Retry",
      "Member Statement": "Member Statement",
      "Program Audit Log": "Program Audit Log",
      "Search text (member, notes, action)": "Search text (member, notes, action)",
      "Refresh Data": "Refresh Data",
      "Export CSV (Statement)": "Export CSV (Statement)",
      "Export CSV (Audit)": "Export CSV (Audit)",
      "Loading latest records...": "Loading latest records...",
      "Amount (TZS)": "Amount (TZS)",
      "Overpayment (TZS)": "Overpayment (TZS)",
      "Balance After (TZS)": "Balance After (TZS)",
      "No transactions match your filters.": "No transactions match your filters.",
      "Amount Per Member (TZS)": "Amount per Member (TZS)",
      "Initiated By": "Initiated By",
      "No audit entries match your filters.": "No audit entries match your filters.",
      "Failed to load transaction audit data.": "Failed to load transaction audit data.",
      "Contribution": "Contribution",
      "Penalty": "Penalty",
      "Loan Disbursement": "Loan Disbursement",
      "Loan Repayment": "Loan Repayment",
      "Withdrawal": "Withdrawal",
      "Adjustment": "Adjustment",
      "Emergency Deduction": "Emergency Deduction",
      "Business Income": "Business Income",
      "Dividend Payout": "Dividend Payout",
      "Dividend Bank Charge": "Dividend Bank Charge",
      "Loan Interest Income": "Loan Interest Income",
      "Defaults Collected": "Defaults Collected",
      // Entry Fee Invoices
      "Entry Fee Invoices": "Entry Fee Invoices",
      "Track all group entry fee payments and their current status": "Track all group entry fee payments and their current status",
      "Search by invoice, member or group...": "Search by invoice, member or group...",
      "Filter Status": "Filter Status",
      "Export Report": "Export Report",
      "Exporting...": "Exporting...",
      "Refresh": "Refresh",
      "All Entry Fee Invoices": "All Entry Fee Invoices",
      "Invoice No": "Invoice No",
      "Member": "Member",
      // Group Management
      "Register new Savvy Community groups and set their initial Chairperson.": "Register new Savvy Community groups and set their initial Chairperson.",
      "Search group by name...": "Search group by name...",
      "Register New Group": "Register New Group",
      "Group Name": "Group Name",
      "Chairperson": "Chairperson",
      "Frequency": "Frequency",
      "Contribution Amount": "Contribution Amount",
      "NMB Account": "NMB Account",
      "Mkoa": "Mkoa",
      "Wilaya": "Wilaya",
      "Upatu?": "Upatu?",
      "Edit Group": "Edit Group",
      "Group Information": "Group Information",
      "Meeting Frequency": "Meeting Frequency",
      "Contribution Amount (TZS)": "Contribution Amount (TZS)",
      "Entry Fee Amount (TZS)": "Entry Fee Amount (TZS)",
      "Required upfront from chairperson and new members. Set 0 to disable.": "Required upfront from chairperson and new members. Set 0 to disable.",
      "Group NMB Account Number": "Group NMB Account Number",
      "Enter the 11-digit NMB business account number.": "Enter the 11-digit NMB business account number.",
      "Required: 11-digit NMB account for automated settlements.": "Required: 11-digit NMB account for automated settlements.",
      "Enable Upatu (chama/rotational savings mode)": "Enable Upatu (chama/rotational savings mode)",
      "Initial Chairperson Info": "Initial Chairperson Info",
      "Full Name": "Full Name",
      "Phone Number": "Phone Number",
      "Email (Optional)": "Email (Optional)",
      "Group name is required.": "Group name is required.",
      "Chairperson name is required.": "Chairperson name is required.",
      "Chairperson phone is required.": "Chairperson phone is required.",
      "Mkoa (Region) is required.": "Mkoa (Region) is required.",
      "Wilaya (District) is required.": "Wilaya (District) is required.",
      "Entry fee cannot be negative.": "Entry fee cannot be negative.",
      "NMB account must be exactly 11 digits.": "NMB account must be exactly 11 digits.",
      "Group Created Successfully!": "Group Created Successfully!",
      "The chairperson will need to activate their account on first login.": "The chairperson will need to activate their account on first login.",
      "Creation Failed": "Creation Failed",
      "This phone number is already registered to another user.": "This phone number is already registered to another user.",
      "A user with this phone number already exists. Please use a different number for the chairperson.": "A user with this phone number already exists. Please use a different number for the chairperson.",
      "Group Updated!": "Group Updated!",
      "Update Failed": "Update Failed",
      "Delete Group?": "Delete Group?",
      "Are you sure you want to remove {{name}}?": "Are you sure you want to remove {{name}}?",
      "Deleted!": "Deleted!",
      "{{name}} has been removed.": "{{name}} has been removed.",
      "Deletion Failed": "Deletion Failed",
      "Yes": "Yes",
      "No": "No",
      "Cancel": "Cancel",
      "Save": "Save",
      "Delete": "Delete",
      // Group Expenses
      "Group Expense Management": "Group Expense Management",
      "Track and approve all group operational expenses": "Track and approve all group operational expenses",
      "Search by Title": "Search by Title",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "Filter by Status": "Filter by Status",
      "All Statuses": "All Statuses",
      "Pending": "Pending",
      "Approved": "Approved",
      "Rejected": "Rejected",
      "New Expense": "New Expense",
      "Total Expenses": "Total Expenses",
      "Approved Expenses": "Approved Expenses",
      "Cost will be split equally across all members": "Cost will be split equally across all members",
      "Rejection Reason:": "Rejection Reason:",
      "Expense Title": "Expense Title",
      "Amount (TZS)": "Amount (TZS)",
      "Submit": "Submit",
      "Confirm Approval": "Confirm Approval",
      "Are you sure you want to approve the expense: {{title}} for {{amount}}?": "Are you sure you want to approve the expense: {{title}} for {{amount}}?",
      "Reject Expense": "Reject Expense",
      "Please provide a reason for rejecting the expense: {{title}}": "Please provide a reason for rejecting the expense: {{title}}",
      "Rejection Reason": "Rejection Reason",
      "Confirm Rejection": "Confirm Rejection",
      "Failed to load expenses.": "Failed to load expenses.",
      "Expense created and sent for approval.": "Expense created and sent for approval.",
      "The expense has been approved.": "The expense has been approved.",
      "The expense has been rejected.": "The expense has been rejected.",
      "Approved!": "Approved!",
      "Rejected!": "Rejected!",
      "Success": "Success",
      "Error": "Error",
      // Emergency Contributions
      "Emergency Contributions": "Emergency Contributions",
      "Chairperson initiates → Katibu reviews → Muhasibu approves & deducts": "Chairperson initiates → Katibu reviews → Muhasibu approves & deducts",
      "Open Emergencies": "Open Emergencies",
      "Event List": "Event List",
      "Initiate Emergency": "Initiate Emergency",
      "No emergency events found.": "No emergency events found.",
      "Event": "Event",
      "Type": "Type",
      "Deduction / Member": "Deduction / Member",
      "Initiated By": "Initiated By",
      "Approval Chain": "Approval Chain",
      "Initiate Emergency Contribution": "Initiate Emergency Contribution",
      "Event Type": "Event Type",
      "Bereavement": "Bereavement",
      "Medical": "Medical",
      "Disaster": "Disaster",
      "Wedding": "Wedding",
      "Other": "Other",
      "Deduction per Member (TZS)": "Deduction per Member (TZS)",
      "e.g., Msiba wa Mwanachama – Neema Peter": "e.g., Member's Funeral – Neema Peter",
      "After creation, the request will be sent to the Secretary and then the Accountant for approval before any deductions are made.": "After creation, the request will be sent to the Secretary and then the Accountant for approval before any deductions are made.",
      "Create": "Create",
      "Emergency Details": "Emergency Details",
      "Deduction/Member:": "Deduction/Member:",
      "Initiated:": "Initiated:",
      "Affected Members (Preview)": "Affected Members (Preview)",
      "Bal. Before": "Bal. Before",
      "Bal. After*": "Bal. After*",
      "Showing a historical snapshot of balances at the time of deduction.": "Showing a historical snapshot of balances at the time of deduction.",
      "Audit Trail": "Audit Trail",
      "By:": "By:",
      "Close": "Close",
      "Pending Secretary": "Pending Secretary",
      "Pending Accountant": "Pending Accountant",
      "Completed": "Completed",
      "Failed to load data": "Failed to load data",
      "Missing data": "Missing data",
      "Please fill event title and a valid deduction amount.": "Please fill event title and a valid deduction amount.",
      "Emergency created": "Emergency created",
      "Pending Secretary approval.": "Pending Secretary approval.",
      "Approve emergency?": "Approve emergency?",
      "This will forward to the next stage.": "This will forward to the next stage.",
      "This action cannot be undone.": "This action cannot be undone.",
      "Reason for rejection (optional)": "Reason for rejection (optional)",
      "Action Complete": "Action Complete",
      "Action Failed": "Action Failed",
      "Event has been approved.": "Event has been approved.",
      "Event has been rejected.": "Event has been rejected.",
      "Approve & Deduct": "Approve & Deduct",
      "Details": "Details",
      "Type:": "Type:",
      // Special Contributions
      "Start Special Contribution Program": "Start Special Contribution Program",
      "Define program details and select participants (subset or all members).": "Define program details and select participants (subset or all members).",
      "Title *": "Title *",
      "e.g., Mama Neema Delivery Support": "e.g., Mama Neema Delivery Support",
      "Target per member (TZS) *": "Target per member (TZS) *",
      "Short reason or context for this program...": "Short reason or context for this program...",
      "Leader:": "Leader:",
      "All Active Members": "All Active Members",
      "Selected (Active)": "Selected (Active)",
      "Target / Member": "Target / Member",
      "Total Target": "Total Target",
      "Select Participants": "Select Participants",
      "Only active members are eligible to be charged. Inactive appear for transparency.": "Only active members are eligible to be charged. Inactive appear for transparency.",
      "Search by name, phone, or role...": "Search by name, phone, or role...",
      "No members match your search.": "No members match your search.",
      "On Start Date, the system will generate a unique invoice with a reference for each selected member and send reminders until the End Date.": "On Start Date, the system will generate a unique invoice with a reference for each selected member and send reminders until the End Date.",
      "Validation Check": "Validation Check",
      "Validate": "Validate",
      "Submitting...": "Submitting...",
      "Create Program": "Create Program",
      "Retry": "Retry",
      "Initiator inactive": "Initiator inactive",
      "Only active members can initiate a program.": "Only active members can initiate a program.",
      "Missing Title": "Missing Title",
      "Please enter a program title.": "Please enter a program title.",
      "Duplicate Active Program": "Duplicate Active Program",
      "Another active program with the same title exists.": "Another active program with the same title exists.",
      "Invalid Target": "Invalid Target",
      "Target per member must be greater than zero.": "Target per member must be greater than zero.",
      "Missing Dates": "Missing Dates",
      "Please select start and end dates.": "Please select start and end dates.",
      "Invalid Timeframe": "Invalid Timeframe",
      "End date must be after start date.": "End date must be after start date.",
      "No Participants": "No Participants",
      "Select at least one active participant.": "Select at least one active participant.",
      "Program Created": "Program Created",
      "Program requires approvals (Chair → Katibu → Muhasibu).": "Program requires approvals (Chair → Katibu → Muhasibu).",
      "Invoices will be generated per member on start.": "Invoices will be generated per member on start.",
      "Special Contribution Programs": "Special Contribution Programs",
      "Monitor program progress, member payments, and handle withdrawals with proper approval chain.": "Monitor program progress, member payments, and handle withdrawals with proper approval chain.",
      "All Programs": "All Programs",
      "My Programs": "My Programs",
      "Start Program": "Start Program",
      "Active Programs": "Active Programs",
      "Closed & Ready for Withdrawal": "Closed & Ready for Withdrawal",
      "Programs": "Programs",
      "Status based on target amount & timeframe closure.": "Status based on target amount & timeframe closure.",
      "Program": "Program",
      "Progress": "Progress",
      "No programs found.": "No programs found.",
      "Could not load members": "Could not load members",
      "Program still active": "Program still active",
      "Withdrawal can only be initiated after the program closes.": "Withdrawal can only be initiated after the program closes.",
      "Request Already Exists": "Request Already Exists",
      "Withdrawal request exists status": "Withdrawal request exists status: {{status}}",
      "Request Withdrawal?": "Request Withdrawal?",
      "Enter beneficiary details for the withdrawable amount of {{amount}} TZS.": "Enter beneficiary details for the withdrawable amount of {{amount}} TZS.",
      "Beneficiary Name": "Beneficiary Name",
      "Beneficiary Account (Bank/Mobile)": "Beneficiary Account (Bank/Mobile)",
      "Purpose of withdrawal (optional)": "Purpose of withdrawal (optional)",
      "Submit Request": "Submit Request",
      "Beneficiary name and account are required.": "Beneficiary name and account are required.",
      "Withdrawal Request Sent!": "Withdrawal Request Sent!",
      "Withdrawal pending chairperson": "Withdrawal pending chairperson approval.",
      "Request Failed": "Request Failed",
      "Not Allowed": "Not Allowed",
      "Only group leadership (Chair, Secretary, Accountant) can perform this action.": "Only group leadership (Chair, Secretary, Accountant) can perform this action.",
      "Action Not Applicable": "Action Not Applicable",
      "This program is not in a pending state.": "This program is not in a pending state.",
      "Approve Program Creation?": "Approve Program Creation?",
      "Reject Program Creation?": "Reject Program Creation?",
      "This will move the program to the next approval stage.": "This will move the program to the next approval stage.",
      "This action will stop the program creation.": "This action will stop the program creation.",
      "Reason for rejection (required)": "Reason for rejection (required)",
      "Enter reason...": "Enter reason...",
      "You must provide a reason for rejection.": "You must provide a reason for rejection.",
      "Action Successful": "Action Successful",
      "Program has been approved.": "Program has been approved.",
      "Program has been rejected.": "Program has been rejected.",
      "Approve Withdrawal Request?": "Approve Withdrawal Request?",
      "Reject Withdrawal Request?": "Reject Withdrawal Request?",
      "This will move the withdrawal to the next approval stage or release funds.": "This will move the withdrawal to the next approval stage or release funds.",
      "This action will reject the withdrawal request.": "This action will reject the withdrawal request.",
      "Withdrawal request has been approved.": "Withdrawal request has been approved.",
      "Withdrawal request has been rejected.": "Withdrawal request has been rejected.",
      "Program now pending approval from the Chairperson.": "Program now pending approval from the Chairperson.",
      "Pending Chair Approval": "Pending Chair Approval",
      "Pending Secretary Approval": "Pending Secretary Approval",
      "Pending Accountant Approval": "Pending Accountant Approval",
      "Closed (Target Reached)": "Closed (Target Reached)",
      "Closed (Time Ended)": "Closed (Time Ended)",
      "Not Requested": "Not Requested",
      "Withdrawal Rejected": "Withdrawal Rejected",
      "Funds Released": "Funds Released",
      "Total Programs": "Total Programs",
      "Member Invoices & Payments": "Member Invoices & Payments",
      "Each member has a unique reference number for this program.": "Each member has a unique reference number for this program.",
      "Base Amount": "Base Amount",
      "DF": "SSC",
      "SSC": "SSC",
      "Total Due": "Total Due",
      "Paid": "Paid",
      "No invoices loaded in this demo. In real system, all participants would appear here.": "No invoices loaded in this demo. In real system, all participants would appear here.",
      "All contributions, DF, approvals and withdrawals for this program will appear in both member statements and program audit logs to comply with SACCOs & microfinance governance standards.": "All contributions, SSC, approvals and withdrawals for this program will appear in both member statements and program audit logs to comply with SACCOs & microfinance governance standards.",
      "All contributions, SSC, approvals and withdrawals for this program will appear in both member statements and program audit logs to comply with SACCOs & microfinance governance standards.": "All contributions, SSC, approvals and withdrawals for this program will appear in both member statements and program audit logs to comply with SACCOs & microfinance governance standards.",
      "Approve Program": "Approve Program",
      "Reject Program": "Reject Program",
      "Request Withdrawal": "Request Withdrawal",
      "Withdrawal Request Details": "Withdrawal Request Details",
      "Beneficiary": "Beneficiary",
      "Account": "Account",
      "Amount": "Amount",
      "Purpose": "Purpose",
      "Rejection Reason": "Rejection Reason",
      "Status:": "Status:",
      "Approval Chain": "Approval Chain",
      "Chair: Pending": "Chair: Pending",
      "Chair: Approved": "Chair: Approved",
      "Secretary: Pending": "Secretary: Pending",
      "Secretary: Approved": "Secretary: Approved",
      "Accountant: Pending": "Accountant: Pending",
      "Accountant: Approved": "Accountant: Approved",
      "No withdrawal details to display.": "No withdrawal details to display.",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "Collected so far": "Collected so far",
      "Program-level goal": "Program-level goal",
      "of target": "of target",


      // Group Management
      "Register new Savvy Community groups and set their initial Chairperson.": "Register new Savvy Community groups and set their initial Chairperson.",
      "Search group by name...": "Search group by name...",
      "Register New Group": "Register New Group",
      "Group Name": "Group Name",
      "Chairperson": "Chairperson",
      "Frequency": "Frequency",
      "Contribution Amount": "Contribution Amount",
      "NMB Account": "NMB Account",
      "Mkoa": "Mkoa",
      "Wilaya": "Wilaya",
      "Upatu?": "Upatu?",
      "Edit Group": "Edit Group",
      "Group Information": "Group Information",
      "Meeting Frequency": "Meeting Frequency",
      "Contribution Amount (TZS)": "Contribution Amount (TZS)",
      "Entry Fee Amount (TZS)": "Entry Fee Amount (TZS)",
      "Required upfront from chairperson and new members. Set 0 to disable.": "Required upfront from chairperson and new members. Set 0 to disable.",
      "Group NMB Account Number": "Group NMB Account Number",
      "Enter the 11-digit NMB business account number.": "Enter the 11-digit NMB business account number.",
      "Required: 11-digit NMB account for automated settlements.": "Required: 11-digit NMB account for automated settlements.",
      "Enable Upatu (chama/rotational savings mode)": "Enable Upatu (chama/rotational savings mode)",
      "Initial Chairperson Info": "Initial Chairperson Info",
      "Full Name": "Full Name",
      "Phone Number": "Phone Number",
      "Email (Optional)": "Email (Optional)",
      "Group name is required.": "Group name is required.",
      "Chairperson name is required.": "Chairperson name is required.",
      "Chairperson phone is required.": "Chairperson phone is required.",
      "Mkoa (Region) is required.": "Mkoa (Region) is required.",
      "Wilaya (District) is required.": "Wilaya (District) is required.",
      "Entry fee cannot be negative.": "Entry fee cannot be negative.",
      "NMB account must be exactly 11 digits.": "NMB account must be exactly 11 digits.",
      "Group Created Successfully!": "Group Created Successfully!",
      "The chairperson will need to activate their account on first login.": "The chairperson will need to activate their account on first login.",
      "Creation Failed": "Creation Failed",
      "This phone number is already registered to another user.": "This phone number is already registered to another user.",
      "A user with this phone number already exists. Please use a different number for the chairperson.": "A user with this phone number already exists. Please use a different number for the chairperson.",
      "Group Updated!": "Group Updated!",
      "Update Failed": "Update Failed",
      "Delete Group?": "Delete Group?",
      "Are you sure you want to remove {{name}}?": "Are you sure you want to remove {{name}}?",
      "Deleted!": "Deleted!",
      "{{name}} has been removed.": "{{name}} has been removed.",
      "Deletion Failed": "Deletion Failed",
      "Yes": "Yes",
      "No": "No",
      "Cancel": "Cancel",
      "Save": "Save",
      "Delete": "Delete",
      "Member": "Member",
      "Amount": "Amount",
      "No invoices found.": "No invoices found.",
      "Failed to load entry fee invoices.": "Failed to load entry fee invoices.",
      "Failed to export invoices.": "Failed to export invoices.",
      "View": "View",
      "PAID": "PAID",
      "PENDING": "PENDING",
      "FAILED": "FAILED",
      // Leader Withdrawal Approvals
      "Member Withdrawal Approvals": "Member Withdrawal Approvals",
      "Workflow: Mwenyekiti → Katibu → Muhasibu. Financial clearance is verified before the final payout.": "Workflow: Mwenyekiti → Katibu → Muhasibu. Financial clearance is verified before the final payout.",
      "Refresh": "Refresh",
      "Refreshing...": "Refreshing...",
      "Waiting for Mwenyekiti": "Waiting for Mwenyekiti",
      "Waiting for Katibu": "Waiting for Katibu",
      "Waiting for Muhasibu": "Waiting for Muhasibu",
      "Finalized": "Finalized",
      "Double-entry ledger entries and retention/refund calculations are created automatically after Muhasibu approval. Once finalized, the member becomes inactive and only reactivates when the group reinstates them.": "Double-entry ledger entries and retention/refund calculations are created automatically after Muhasibu approval. Once finalized, the member becomes inactive and only reactivates when the group reinstates them.",
      "Search by member name or reason...": "Search by member name or reason...",
      "All Statuses": "All Statuses",
      "Approvals": "Approvals",
      "Actions": "Actions",
      "Reason": "Reason",
      "Submitted": "Submitted",
      "No withdrawal requests match your filters.": "No withdrawal requests match your filters.",
      "View full details": "View full details",
      "Approve & move to the next stage": "Approve & move to the next stage",
      "Approve disabled tooltip": "You can only approve requests that are currently waiting for your role.",
      "Reject request": "Reject request",
      "Reject disabled tooltip": "You can only reject requests that are currently waiting for your role.",
      "Approval pending label": "{{role}}: Pending",
      "Withdrawal Request Details": "Withdrawal Request Details",
      "Rejected: {{reason}}": "Rejected: {{reason}}",
      "Submitted on": "Submitted on",
      "Reason for withdrawal": "Reason for withdrawal",
      "Retention Percent": "Retention Percent",
      "Retention Amount": "Retention Amount",
      "Refund Amount": "Refund Amount",
      "Approval progress": "Approval progress",
      "Approval trail": "Approval trail",
      "Mwenyekiti": "Mwenyekiti",
      "Katibu": "Katibu",
      "Muhasibu": "Muhasibu",
      "Approved by {{name}} on {{date}}": "Approved by {{name}} on {{date}}",
      "Awaiting action": "Awaiting action",
      "Close": "Close",
      "Withdrawal approvals are only accessible to the Mwenyekiti, Katibu and Muhasibu roles.": "Withdrawal approvals are only accessible to the Mwenyekiti, Katibu and Muhasibu roles.",
      "Unable to load withdrawal requests.": "Unable to load withdrawal requests.",
      "Approve withdrawal request?": "Approve withdrawal request?",
      "Approve withdrawal text": "This will forward {{member}}'s request to the next approval stage.",
      "Yes, proceed": "Yes, proceed",
      "Action recorded": "Action recorded",
      "Workflow moved to next approver": "The workflow has moved to the next approver.",
      "Unable to approve": "Unable to approve",
      "Please try again.": "Please try again.",
      "Reject withdrawal?": "Reject withdrawal?",
      "Reject withdrawal note": "Please capture a short note for the audit trail.",
      "Rejection reason": "Rejection reason",
      "Rejection reason placeholder": "e.g. Member still has an outstanding loan",
      "Rejection reason is required.": "Rejection reason is required.",
      "Reject": "Reject",
      "Request rejected": "Request rejected",
      "Member notified": "{{member}} has been notified about the decision.",
      "Unable to reject": "Unable to reject",
      "Missing fields": "Missing fields",
      "Name, Type, and Capital are required.": "Name, Type, and Capital are required.",
      "Track your savings, loans, and performance": "Fuatilia akiba zako, mikopo, na maendeleo yako",
      "Total Contributions (TZS)": "Jumla ya Michango (TZS)",
      "Loan Balance (TZS)": "Salio la Mkopo (TZS)",
      "Penalties (TZS)": "Adhabu (TZS)",
      "Dividends (TZS)": "Mgaao (TZS)",
      "My Weekly Contributions (TZS, in K)": "Michango ya Kila Wiki (TZS, kwa maelfu)",
      "Last 5 weeks — contributions vs captured disbursements": "Wiki 5 zilizopita — michango dhidi ya utoaji fedha",
      "Live data": "Data ya moja kwa moja",
      "Make Contribution": "Toa Mchango",
      "View My Statement": "Tazama Taarifa Yangu",
      "Request Loan": "Omba Mkopo",
      "Upcoming Deadlines & Reminders": "Makataa na Vikumbusho Vijavyo",
      "No upcoming reminders at the moment.": "Hakuna vikumbusho kwa sasa.",
      "Recent Transactions": "Recent Transactions",
      // System Settings
      "System Settings": "System Settings",
      "Configure core financial parameters. All changes are logged.": "Configure core financial parameters. All changes are logged.",
      "Financial Parameters": "Financial Parameters",
      "Interest applies to loans; OF applies to any deposit; penalties are posted daily at 19:01.": "Interest applies to loans; SSC applies only to deposit transactions; penalties are posted daily at 19:01.",
      "Interest applies to loans; SSC applies only to deposit transactions; penalties are posted daily at 19:01.": "Interest applies to loans; SSC applies only to deposit transactions; penalties are posted daily at 19:01.",
      "Interest Rate (%)": "Interest Rate (%)",
      "Operation Fee (OF %)": "System Service Charge (SSC %)",
      "System Service Charge (SSC %)": "System Service Charge (SSC %)",
      "Applies globally to all contributions.": "Applies globally to deposit transactions only. Default is 10%.",
      "Applies globally to deposit transactions only. Default is 10%.": "Applies globally to deposit transactions only. Default is 10%.",
      "Managed centrally by the system administrator.": "Managed centrally by the system administrator. Default is 10%.",
      "Managed centrally by the system administrator. Default is 10%.": "Managed centrally by the system administrator. Default is 10%.",
      "Bank Charge (%)": "Bank Charge (%)",
      "Percent deducted from dividend pools for bank / processing charges.": "Percent deducted from dividend pools for bank / processing charges.",
      "Retention Percent (%)": "Retention Percent (%)",
      "Percent retained when members withdraw.": "Percent retained when members withdraw.",
      "Managed centrally by the platform admin.": "Managed centrally by the platform admin.",
      "Required Deposit (%)": "Required Deposit (%)",
      "Minimum savings percentage before a member can borrow.": "Minimum savings percentage before a member can borrow.",
      "Penalty Amount (TZS)": "Penalty Amount (TZS)",
      "Applied uniformly regardless of repayment schedule.": "Applied uniformly regardless of repayment schedule.",
      "Penalty Execution Time": "Penalty Execution Time",
      "Daily cutoff for applying late penalties (24h).": "Daily cutoff for applying late penalties (24h).",
      "Auto-deactivate members in arrears": "Auto-deactivate members in arrears",
      "Entry Fee Amount": "Entry Fee Amount",
      "One-time fee per member when joining.": "One-time fee per member when joining.",
      "Statement Fee Per Page": "Statement Fee Per Page",
      "System Registration Fee (SRF)": "System Registration Fee (SRF)",
      "System Annual Fee (SAF)": "System Annual Fee (SAF)",
      "SAF Payment Deadline": "SAF Payment Deadline",
      "SAF Deadline Month": "SAF Deadline Month",
      "SAF Deadline Day": "SAF Deadline Day",
      "Applies to newly created members only. Default is 5,000 TZS.": "Applies to newly created members only. Default is 5,000 TZS.",
      "Yearly access fee. Default is 10,000 TZS.": "Yearly access fee. Default is 10,000 TZS.",
      "Calendar month used for the annual SAF deadline.": "Calendar month used for the annual SAF deadline.",
      "Calendar day used for the annual SAF deadline.": "Calendar day used for the annual SAF deadline.",
      "Invalid SRF Amount": "Invalid SRF Amount",
      "System Registration Fee cannot be negative.": "System Registration Fee cannot be negative.",
      "Invalid SAF Amount": "Invalid SAF Amount",
      "System Annual Fee cannot be negative.": "System Annual Fee cannot be negative.",
      "Invalid SAF Deadline Month": "Invalid SAF Deadline Month",
      "SAF deadline month must be between 1 and 12.": "SAF deadline month must be between 1 and 12.",
      "Invalid SAF Deadline Day": "Invalid SAF Deadline Day",
      "SAF deadline day must be between 1 and 31.": "SAF deadline day must be between 1 and 31.",
      "Billable fee per page when downloading member statements.": "Billable fee per page when downloading member statements.",
      "Default Repayment Method": "Default Repayment Method",
      "Daily": "Daily",
      "Weekly": "Weekly",
      "Monthly": "Monthly",
      "Restrict Sunday transactions (create/repayment not allowed)": "Restrict Sunday transactions (create/repayment not allowed)",
      "Save Settings": "Save Settings",
      "Saving...": "Saving...",
      "Reset to Defaults": "Reset to Defaults",
      "Configuration Audit Trail": "Configuration Audit Trail",
      "No audit entries yet.": "No audit entries yet.",
      "Unsaved changes": "Unsaved changes",
      "Up to date": "Up to date",
      "Failed to load settings": "Failed to load settings",
      "Invalid Interest Rate": "Invalid Interest Rate",
      "Interest must be between 0% and 100%.": "Interest must be between 0% and 100%.",
      "Invalid DF%": "Invalid SSC%",
      "Invalid SSC%": "Invalid SSC%",
      "DF must be between 0% and 100%.": "SSC must be between 0% and 100%.",
      "SSC must be between 0% and 100%.": "SSC must be between 0% and 100%.",
      "Invalid Penalty": "Invalid Penalty",
      "Penalty amounts cannot be negative.": "Penalty amounts cannot be negative.",
      "Invalid Retention %": "Invalid Retention %",
      "Retention must be between 0% and 100%.": "Retention must be between 0% and 100%.",
      "Invalid Required Deposit %": "Invalid Required Deposit %",
      "Required deposit must be between 0% and 100%.": "Required deposit must be between 0% and 100%.",
      "Invalid Bank Charge %": "Invalid Bank Charge %",
      "Bank charge must be between 0% and 100%.": "Bank charge must be between 0% and 100%.",
      "Settings Saved": "Settings Saved",
      "Save failed": "Save failed",
      "Reset to Defaults?": "Reset to Defaults?",
      "This will revert settings and permissions to default recommendations.": "This will revert settings and permissions to default recommendations.",
      "Reset": "Reset",
      "Reset Complete": "Reset Complete",
      "Loading system settings...": "Loading system settings...",
      "Group System Settings": "Group System Settings",
      "These settings affect only your group.": "These settings affect only your group.",
      "Platform System Settings": "Platform System Settings",
      "Manage platform-wide defaults. Only operation fee is configurable at this level.": "Manage platform-wide defaults. Only System Service Charge (SSC) is configurable at this level.",
      "Manage platform-wide defaults. Only System Service Charge (SSC) is configurable at this level.": "Manage platform-wide defaults. Only System Service Charge (SSC) is configurable at this level.",
      "Contribute according to your group terms ({{frequency}}). Each deposit includes a {{percent}}% System Service Charge (SSC).": "Contribute according to your group terms ({{frequency}}). Each deposit includes a {{percent}}% System Service Charge (SSC).",
      "SSC: {{amount}}": "SSC: {{amount}}",
      "Charge: {{amount}}": "Charge: {{amount}}",
      "Outstanding SSC (optional)": "Outstanding SSC (optional)",
      "Outstanding charge (optional)": "Outstanding charge (optional)",
    },
  },
  sw: {
    translation: {
      "Current Total Due": "Jumla Inayodaiwa Sasa",
      "Current Total Due (TZS)": "Jumla Inayodaiwa Sasa (TZS)",
      "Outstanding Base": "Msingi Unaobaki",
      "Current SSC": "SSC ya Sasa",
      "Current Bank Charge": "Ada ya Benki ya Sasa",
      "Base Allocated": "Msingi Uliolipwa",
      "Original Base": "Msingi wa Awali",
      "Original SSC": "SSC ya Awali",
      "Original Total": "Jumla ya Awali",
      "Paid: {{date}}": "Imelipwa: {{date}}",
      "welcome": "Karibu",
      Dashboard: "Dashibodi",
      "users": "Watumiaji",
      "settings": "Mipangilio",
      "logout": "Ondoka",
      "addUser": "Ongeza Mtumiaji",
      "members": "Wanachama",
      "contributions": "Michango",
      "Loans": "Mikopo",
      "Loan": "Mkopo",
      "Member": "Mwanachama",
      "Group": "Kundi",
      "Borrower": "Mkopa",
      "Outstanding": "Inayosubiri",
      "Member": "Member",
      "Add Member": "Add Member",
      "language": "Lugha",
      "Manage the system and oversee all groups": "Simamia mfumo na vikundi vyote",
      "Group Contributions": "Michango ya Kundi",
      "Group Management": "Usimamizi wa Kundi",
      "Desk Officer Dashboard": "Dashibodi ya Afisa wa Dawati",
      "Member Dashboard": "Dashibodi ya Mwanachama",
      "Admin Dashboard": "Dashibodi ya Msimamizi",
      "Accountant Dashboard": "Dashibodi ya Mhasibu",
      "Chairperson Dashboard": "Dashibodi ya Mwenyekiti",

      "Loan Management": "Usimamizi wa Mikopo",
      'All Loans': 'Mikopo Yote',
      "My Loans": "Mikopo Yangu",
      "All Status": "Hali Zote",
      "Active": "Inaendelea",
      "Pending": "INASUBIRI",
      "Search loan or member...": "Tafuta mkopo au mwanachama",
      "Apply Loan": "Omba Mkopo",
      "Failed to load data": "Imeshindwa kupakia data",
      "Total Groups": "Jumla ya Vikundi",
      "Total Members": "Jumla ya Wanachama",
      "New Groups (This Month)": "Vikundi Vipya (Mwezi Huu)",
      "Total Transactions (This Month)": "Miamala Yote (Mwezi Huu)",
      "Loan Disbursement vs Contributions (trend)": "Utoaji wa Mikopo dhidi ya Michango (mwelekeo)",
      "Loan Disbursements": "Utoaji wa Mikopo",
      "Disbursements": "Utoaji wa Fedha",
      "Quick Actions": "Vitendo vya Haraka",
      "User Management": "Usimamizi wa Watumiaji",
      "System Reports": "Ripoti za Mfumo",
      "View Audit Logs": "Tazama Kumbukumbu za Ukaguzi",
      "Recent Group Registrations": "Usajili wa Vikundi Uliofanyika Hivi Karibuni",
      "View All": "Tazama Zote",
      "Chair": "Mwenyekiti",
      "Members": "Wanachama",
      "Status": "Hali",
      "Pending Approvals": "Idhini Zinazosubiri",
      "Approved Groups": "Vikundi Vilivyoidhinishwa",
      "No recent group registrations found.": "Hakuna usajili mpya wa vikundi.",
      "Loading dashboard data...": "Inapakia taarifa za dashibodi...",
      "Failed to load dashboard: {{error}}": "Imeshindwa kupakia dashibodi: {{error}}",
      "Register groups, manage approvals, and keep leaders informed": "Sajili vikundi, simamia idhini, na wafahamishe viongozi.",
      "Group Registration Trend (Last 6 Months)": "Mwelekeo wa Usajili wa Vikundi (Miezi 6 Iliyopita)",
      "No transaction data available for the selected period.": "Hakuna taarifa za miamala kwa kipindi kilichochaguliwa.",
      "Review Pending Approvals": "Kagua Idhini Zinazosubiri",
      "Generate Registration Link": "Tengeneza Kiungo cha Usajili",
      "Frequency": "Marudio",
      "Chairperson": "Mwenyekiti",
      "N/A": "Hakuna",
      "Approved": "Imeidhinishwa",
      "Pending": "Inasubiri",
      "Unable to load dashboard data": "Imeshindwa kupakia taarifa za dashibodi",
      "© {year} Savvy Community": "© {year} Savvy Community",
      "just now": "sasa hivi",
      "{{count}} seconds ago": "sekunde {{count}} zilizopita",
      "{{count}} minutes ago": "dakika {{count}} zilizopita",
      "{{count}} hours ago": "saa {{count}} zilizopita",
      "{{count}} days ago": "siku {{count}} zilizopita",
      "Weekly Contributions (TZS, in K)": "Michango ya Kila Wiki (TZS, kwa maelfu)",
      "Last 6 weeks": "Wiki 6 zilizopita",
      "Up to date": "Imefika hadi sasa",
      "Not enough transaction data yet.": "Hakuna data ya miamala ya kutosha bado.",
      "View Group Summary": "Tazama Muhtasari wa Kundi",
      "Approve Loan": "Idhinisha Mkopo",
      "Recent Member Contributions (Last 5)": "Michango ya Hivi Karibuni ya Wanachama (5 za mwisho)",
      "Operation Fee (OF)": "Tozo ya Huduma ya Mfumo (SSC)",
      "System Service Charge (SSC)": "Tozo ya Huduma ya Mfumo (SSC)",
      "System Service Charge (SSC):": "Tozo ya Huduma ya Mfumo (SSC):",
      "No contributions recorded yet.": "Hakuna michango iliyorekodiwa bado.",
      "Your Group": "Kikundi Chako",
      "Next Contribution": "Michango Ijayo",
      "TBD": "Inatarajiwa",
      "Active Members": "Wanachama Hai",
      "Current Balance (TZS)": "Salio la Sasa (TZS)",
      "Pending Loans": "Mikopo Inayosubiri",
      "No active membership found.": "Hakuna uanachama hai uliopatikana.",
      "Active Loans": "Mikopo Hai",
      "Pending Loans": "Mikopo Inayosubiri",
      "Total Outstanding": "Jumla Inayosubiri",
      "Accumulated Penalties": "Adhabu Zilizokusanywa",
      "Pending Accountant": "Inayosubiri Mhasibu",
      "Weekly": "Kila wiki",
      "Monthly": "Kila mwezi",
      "Quarterly": "Kila robo mwaka",
      "Yearly": "Kila mwaka",
      "month(s)": "Mwezi(mi)",
      "Week(s)": "Wiki(zi)",
      "Year(s)": "Mwaka(mi)",
      "Principal": "Msingi",
      "Interest": "Riba",
      "Total": "Jumla",
      "Repayment Schedule": "Ratiba ya Malipo",
      "Status is based on multi-level approval and repayment progress.": "Hali inategemea idhini ya ngazi nyingi na maendeleo ya malipo.",
      "Penalties": "Adhabu",
      "Penalty": "Adhabu",
      "Total Payable": "Jumla Inayolipika",
      "Collected": "Ilikusanywa",
      "Installment": " Malipo",
      "Installments": " Malipo",
      "Due Date": " Tarehe ya Kumalizika",
      "Amount Due": " Kiasi Kinachotakiwa",
      "Paid": "Imelipwa",
      "Balance": " Salio",
      "Collected / Outstanding": " Imekusanywa / Inayosubiriwa",
      "Penalty so far": " Adhabu hadi sasa",
      "Penalty Waiver Requests": " Maombi ya Msamaha wa Adhabu",
      "Period": " Kipindi",
      "Reason": " Sababu",
      "Actions": " Vitendo",
      "View loan portfolio, approvals, repayments and penalty waivers for your Vikoba/SACCOS group.": "Tazama jalada la mikopo, idhini, malipo na msamaha wa adhabu kwa kundi lako la Savvy Community/SACCOS.",
      "Member Management": "Usimamizi wa Wanachama",
      // Group Management
      "Register new Savvy Community groups and set their initial Chairperson.": "Sajili vikundi vipya vya Savvy Community na uweke Mwenyekiti wa awali.",
      "Search group by name...": "Tafuta kikundi kwa jina...",
      "Register New Group": "Sajili Kikundi Kipya",
      "Group Name": "Jina la Kikundi",
      "Chairperson": "Mwenyekiti",
      "Frequency": "Marudio",
      "Contribution Amount": "Kiasi cha Mchango",
      "NMB Account": "Akaunti ya NMB",
      "Mkoa": "Mkoa",
      "Wilaya": "Wilaya",
      "Upatu?": "Upatu?",
      "Edit Group": "Hariri Kikundi",
      "Group Information": "Taarifa za Kikundi",
      "Meeting Frequency": "Marudio ya Mikutano",
      "Contribution Amount (TZS)": "Kiasi cha Mchango (TZS)",
      "Entry Fee Amount (TZS)": "Kiasi cha Kiingilio (TZS)",
      "Required upfront from chairperson and new members. Set 0 to disable.": "Inahitajika mapema kutoka kwa mwenyekiti na wanachama wapya. Weka 0 kutoitumia.",
      "Group NMB Account Number": "Namba ya Akaunti ya NMB ya Kikundi",
      "Enter the 11-digit NMB business account number.": "Ingiza namba 11 za akaunti ya biashara ya NMB.",
      "Required: 11-digit NMB account for automated settlements.": "Inahitajika: Akaunti ya NMB ya namba 11 kwa malipo ya kiotomatiki.",
      "Enable Upatu (chama/rotational savings mode)": "Wezesha Upatu (mfumo wa kuzungusha akiba)",
      "Initial Chairperson Info": "Taarifa za Awali za Mwenyekiti",
      "Full Name": "Jina Kamili",
      "Phone Number": "Namba ya Simu",
      "Email (Optional)": "Barua Pepe (Si lazima)",
      "Group name is required.": "Jina la kikundi linahitajika.",
      "Chairperson name is required.": "Jina la mwenyekiti linahitajika.",
      "Chairperson phone is required.": "Namba ya simu ya mwenyekiti inahitajika.",
      "Mkoa (Region) is required.": "Mkoa unahitajika.",
      "Wilaya (District) is required.": "Wilaya inahitajika.",
      "Entry fee cannot be negative.": "Kiingilio hakiwezi kuwa hasi.",
      "NMB account must be exactly 11 digits.": "Akaunti ya NMB lazima iwe na namba 11 kamili.",
      "Group Created Successfully!": "Kikundi Kimesajiliwa Kikamilifu!",
      "The chairperson will need to activate their account on first login.": "Mwenyekiti atahitaji kuamilisha akaunti yake anapoingia kwa mara ya kwanza.",
      "Creation Failed": "Usajili Umeshindwa",
      "This phone number is already registered to another user.": "Namba hii ya simu imesajiliwa na mtumiaji mwingine.",
      "A user with this phone number already exists. Please use a different number for the chairperson.": "Mtumiaji mwenye namba hii ya simu tayari yupo. Tafadhali tumia namba tofauti kwa mwenyekiti.",
      "Group Updated!": "Kikundi Kimesasishwa!",
      "Update Failed": "Sasisho Limeshindwa",
      "Delete Group?": "Futa Kikundi?",
      "Are you sure you want to remove {{name}}?": "Una uhakika unataka kufuta {{name}}?",
      "Deleted!": "Imefutwa!",
      "{{name}} has been removed.": "{{name}} imeondolewa.",
      "Deletion Failed": "Ufutaji Umeshindwa",
      "Yes": "Ndiyo",
      "No": "Hapana",
      "Cancel": "Ghairi",
      "Save": "Hifadhi",
      "Delete": "Futa",
      // Group Expenses
      "Group Expense Management": "Usimamizi wa Matumizi ya Kikundi",
      "Track and approve all group operational expenses": "Fuatilia na idhinisha matumizi yote ya uendeshaji ya kikundi",
      "Search by Title": "Tafuta kwa Kichwa",
      "Start Date": "Tarehe ya Kuanza",
      "End Date": "Tarehe ya Kumaliza",
      "Filter by Status": "Chuja kwa Hali",
      "All Statuses": "Hali Zote",
      "Pending": "Inasubiri",
      "Approved": "Imeidhinishwa",
      "Rejected": "Imekataliwa",
      "New Expense": "Matumizi Mapya",
      "Total Expenses": "Jumla ya Matumizi",
      "Approved Expenses": "Matumizi Yaliyoidhinishwa",
      "Cost will be split equally across all members": "Gharama itagawanywa sawa kwa wanachama wote",
      "Rejection Reason:": "Sababu ya Kukataliwa:",
      "Expense Title": "Kichwa cha Matumizi",
      "Amount (TZS)": "Kiasi (TZS)",
      "Submit": "Wasilisha",
      "Confirm Approval": "Thibitisha Idhini",
      "Are you sure you want to approve the expense: {{title}} for {{amount}}?": "Una uhakika unataka kuidhinisha matumizi: {{title}} kwa {{amount}}?",
      "Reject Expense": "Kataa Matumizi",
      "Please provide a reason for rejecting the expense: {{title}}": "Tafadhali toa sababu ya kukataa matumizi: {{title}}",
      "Rejection Reason": "Sababu ya Kukataliwa",
      "Confirm Rejection": "Thibitisha Kukataliwa",
      "Failed to load expenses.": "Imeshindwa kupakia matumizi.",
      "Expense created and sent for approval.": "Matumizi yameundwa na kutumwa kwa idhini.",
      "The expense has been approved.": "Matumizi yameidhinishwa.",
      "The expense has been rejected.": "Matumizi yamekataliwa.",
      "Approved!": "Imeidhinishwa!",
      "Rejected!": "Imekataliwa!",
      "Success": "Imefanikiwa",
      "Error": "Hitilafu",
      // Group Expenses
      "Group Expense Management": "Usimamizi wa Matumizi ya Kikundi",
      "Track and approve all group operational expenses": "Fuatilia na idhinisha matumizi yote ya uendeshaji ya kikundi",
      "Search by Title": "Tafuta kwa Kichwa",
      "Start Date": "Tarehe ya Kuanza",
      "End Date": "Tarehe ya Kumaliza",
      "Filter by Status": "Chuja kwa Hali",
      "All Statuses": "Hali Zote",
      "Pending": "Inasubiri",
      "Approved": "Imeidhinishwa",
      "Rejected": "Imekataliwa",
      "New Expense": "Matumizi Mapya",
      "Total Expenses": "Jumla ya Matumizi",
      "Approved Expenses": "Matumizi Yaliyoidhinishwa",
      "Cost will be split equally across all members": "Gharama itagawanywa sawa kwa wanachama wote",
      "Rejection Reason:": "Sababu ya Kukataliwa:",
      "Expense Title": "Kichwa cha Matumizi",
      "Amount (TZS)": "Kiasi (TZS)",
      "Submit": "Wasilisha",
      "Confirm Approval": "Thibitisha Idhini",
      "Are you sure you want to approve the expense: {{title}} for {{amount}}?": "Una uhakika unataka kuidhinisha matumizi: {{title}} kwa {{amount}}?",
      "Reject Expense": "Kataa Matumizi",
      "Please provide a reason for rejecting the expense: {{title}}": "Tafadhali toa sababu ya kukataa matumizi: {{title}}",
      "Rejection Reason": "Sababu ya Kukataliwa",
      "Confirm Rejection": "Thibitisha Kukataliwa",
      "Failed to load expenses.": "Imeshindwa kupakia matumizi.",
      "Expense created and sent for approval.": "Matumizi yameundwa na kutumwa kwa idhini.",
      "The expense has been approved.": "Matumizi yameidhinishwa.",
      "The expense has been rejected.": "Matumizi yamekataliwa.",
      "Approved!": "Imeidhinishwa!",
      "Rejected!": "Imekataliwa!",
      "Success": "Imefanikiwa",
      "Error": "Hitilafu",
      // Emergency Contributions
      "Emergency Contributions": "Michango ya Dharura",
      "Chairperson initiates → Katibu reviews → Muhasibu approves & deducts": "Mwenyekiti anaanzisha → Katibu anapitia → Mhasibu anaidhinisha na kukata",
      "Open Emergencies": "Dharura Zilizo Wazi",
      "Event List": "Orodha ya Matukio",
      "Initiate Emergency": "Anzisha Dharura",
      "No emergency events found.": "Hakuna matukio ya dharura yaliyopatikana.",
      "Event": "Tukio",
      "Type": "Aina",
      "Deduction / Member": "Makato / Mwanachama",
      "Initiated By": "Imeanzishwa na",
      "Approval Chain": "Mlolongo wa Idhini",
      "Initiate Emergency Contribution": "Anzisha Mchango wa Dharura",
      "Event Type": "Aina ya Tukio",
      "Bereavement": "Msiba",
      "Medical": "Matibabu",
      "Disaster": "Maafa",
      "Wedding": "Harusi",
      "Other": "Mengineyo",
      "Deduction per Member (TZS)": "Makato kwa Mwanachama (TZS)",
      "e.g., Msiba wa Mwanachama – Neema Peter": "mfano: Msiba wa Mwanachama – Neema Peter",
      "After creation, the request will be sent to the Secretary and then the Accountant for approval before any deductions are made.": "Baada ya kuunda, ombi litatumwa kwa Katibu na kisha kwa Mhasibu kwa idhini kabla ya makato yoyote kufanywa.",
      "Create": "Unda",
      "Emergency Details": "Maelezo ya Dharura",
      "Deduction/Member:": "Makato/Mwanachama:",
      "Initiated:": "Imeanzishwa:",
      "Affected Members (Preview)": "Wanachama Walioathirika (Hakiki)",
      "Bal. Before": "Salio Kabla",
      "Bal. After*": "Salio Baada*",
      "Showing a historical snapshot of balances at the time of deduction.": "Inaonyesha picha ya kihistoria ya salio wakati wa makato.",
      "Audit Trail": "Ukaguzi",
      "By:": "Na:",
      "Close": "Funga",
      "Pending Secretary": "Inasubiri Katibu",
      "Pending Accountant": "Inasubiri Mhasibu",
      "Completed": "Imekamilika",
      "Failed to load data": "Imeshindwa kupakia data",
      "Missing data": "Data inakosekana",
      "Please fill event title and a valid deduction amount.": "Tafadhali jaza kichwa cha tukio na kiasi sahihi cha makato.",
      "Emergency created": "Dharura imeundwa",
      "Pending Secretary approval.": "Inasubiri idhini ya Katibu.",
      "Approve emergency?": "Idhinisha dharura?",
      "This will forward to the next stage.": "Hii itapeleka hatua inayofuata.",
      "This action cannot be undone.": "Hatua hii haiwezi kubatilishwa.",
      "Reason for rejection (optional)": "Sababu ya kukataa (si lazima)",
      "Action Complete": "Hatua Imekamilika",
      "Action Failed": "Hatua Imeshindwa",
      "Event has been approved.": "Tukio limeidhinishwa.",
      "Event has been rejected.": "Tukio limekataliwa.",
      "Approve & Deduct": "Idhinisha & Kata",
      "Details": "Maelezo",
      "Type:": "Aina:",
      // Special Contributions
      "Start Special Contribution Program": "Anzisha Programu ya Mchango Maalum",
      "Define program details and select participants (subset or all members).": "Fafanua maelezo ya programu na chagua washiriki (kundi dogo au wanachama wote).",
      "Title *": "Kichwa *",
      "e.g., Mama Neema Delivery Support": "mfano: Mchango wa Kujifungua wa Mama Neema",
      "Target per member (TZS) *": "Lengo kwa mwanachama (TZS) *",
      "Short reason or context for this program...": "Sababu fupi au muktadha wa programu hii...",
      "Leader:": "Kiongozi:",
      "All Active Members": "Wanachama Wote Hai",
      "Selected (Active)": "Waliochaguliwa (Hai)",
      "Target / Member": "Lengo / Mwanachama",
      "Total Target": "Jumla ya Lengo",
      "Select Participants": "Chagua Washiriki",
      "Only active members are eligible to be charged. Inactive appear for transparency.": "Wanachama hai pekee ndio wanaostahiki kutozwa. Wasio hai huonekana kwa uwazi.",
      "Search by name, phone, or role...": "Tafuta kwa jina, simu, au nafasi...",
      "No members match your search.": "Hakuna wanachama wanaolingana na utafutaji wako.",
      "On Start Date, the system will generate a unique invoice with a reference for each selected member and send reminders until the End Date.": "Katika Tarehe ya Kuanza, mfumo utazalisha ankara ya kipekee yenye kumbukumbu kwa kila mwanachama aliyechaguliwa na kutuma vikumbusho hadi Tarehe ya Kumaliza.",
      "Validation Check": "Uhakiki",
      "Validate": "Hakiki",
      "Submitting...": "Inawasilisha...",
      "Create Program": "Unda Programu",
      "Retry": "Jaribu Tena",
      "Initiator inactive": "Mwanzilishi si hai",
      "Only active members can initiate a program.": "Wanachama hai pekee ndio wanaoweza kuanzisha programu.",
      "Missing Title": "Kichwa Kinakosekana",
      "Please enter a program title.": "Tafadhali ingiza kichwa cha programu.",
      "Duplicate Active Program": "Programu Hai Iliyojirudia",
      "Another active program with the same title exists.": "Programu nyingine hai yenye kichwa kama hicho ipo.",
      "Invalid Target": "Lengo Batili",
      "Target per member must be greater than zero.": "Lengo kwa mwanachama lazima liwe zaidi ya sifuri.",
      "Missing Dates": "Tarehe Zinakosekana",
      "Please select start and end dates.": "Tafadhali chagua tarehe za kuanza na kumaliza.",
      "Invalid Timeframe": "Muda Batili",
      "End date must be after start date.": "Tarehe ya kumaliza lazima iwe baada ya tarehe ya kuanza.",
      "No Participants": "Hakuna Washiriki",
      "Select at least one active participant.": "Chagua mshiriki mmoja hai.",
      "Program Created": "Programu Imeundwa",
      "Program requires approvals (Chair → Katibu → Muhasibu).": "Programu inahitaji idhini (Chair → Katibu → Muhasibu).",
      "Invoices will be generated per member on start.": "Ankara zitazalishwa kwa kila mwanachama kuanza.",
      "Special Contribution Programs": "Programu za Michango Maalum",
      "Monitor program progress, member payments, and handle withdrawals with proper approval chain.": "Fuatilia maendeleo ya programu, malipo ya wanachama, na shughulikia uondoaji kwa mlolongo wa idhini ufaao.",
      "All Programs": "Programu Zote",
      "My Programs": "Programu Zangu",
      "Start Program": "Anzisha Programu",
      "Active Programs": "Programu Hai",
      "Closed & Ready for Withdrawal": "Zilizofungwa & Tayari kwa Uondoaji",
      "Programs": "Programu",
      "Status based on target amount & timeframe closure.": "Hali kulingana na kiasi cha lengo & kufungwa kwa muda.",
      "Program": "Programu",
      "Progress": "Maendeleo",
      "No programs found.": "Hakuna programu zilizopatikana.",
      "Could not load members": "Imeshindwa kupakia wanachama",
      "Program still active": "Programu bado ipo hai",
      "Withdrawal can only be initiated after the program closes.": "Uondoaji unaweza kuanzishwa tu baada ya programu kufungwa.",
      "Request Already Exists": "Ombi Tayari Lipo",
      "Withdrawal request exists status": "Hali ya ombi la uondoaji ipo: {{status}}",
      "Request Withdrawal?": "Omba Uondoaji?",
      "Enter beneficiary details for the withdrawable amount of {{amount}} TZS.": "Ingiza maelezo ya mfaidika kwa kiasi kinachoweza kutolewa cha {{amount}} TZS.",
      "Beneficiary Name": "Jina la Mfaidika",
      "Beneficiary Account (Bank/Mobile)": "Akaunti ya Mfaidika (Benki/Simu)",
      "Purpose of withdrawal (optional)": "Sababu ya uondoaji (si lazima)",
      "Submit Request": "Wasilisha Ombi",
      "Beneficiary name and account are required.": "Jina la mfaidika na akaunti zinahitajika.",
      "Withdrawal Request Sent!": "Ombi la Uondoaji Limetumwa!",
      "Withdrawal pending chairperson": "Uondoaji unasubiri idhini ya mwenyekiti.",
      "Request Failed": "Ombi Limeshindwa",
      "Not Allowed": "Hairuhusiwi",
      "Only group leadership (Chair, Secretary, Accountant) can perform this action.": "Uongozi wa kikundi pekee (Mwenyekiti, Katibu, Mhasibu) ndio wanaoweza kufanya hatua hii.",
      "Action Not Applicable": "Hatua Haitumiki",
      "This program is not in a pending state.": "Programu hii haipo katika hali ya kusubiri.",
      "Approve Program Creation?": "Idhinisha Uundaji wa Programu?",
      "Reject Program Creation?": "Kataa Uundaji wa Programu?",
      "This will move the program to the next approval stage.": "Hii itapeleka programu kwenye hatua inayofuata ya idhini.",
      "This action will stop the program creation.": "Hatua hii itasimamisha uundaji wa programu.",
      "Reason for rejection (required)": "Sababu ya kukataa (inahitajika)",
      "Enter reason...": "Ingiza sababu...",
      "You must provide a reason for rejection.": "Lazima utoe sababu ya kukataa.",
      "Action Successful": "Hatua Imefanikiwa",
      "Program has been approved.": "Programu imeidhinishwa.",
      "Program has been rejected.": "Programu imekataliwa.",
      "Approve Withdrawal Request?": "Idhinisha Ombi la Uondoaji?",
      "Reject Withdrawal Request?": "Kataa Ombi la Uondoaji?",
      "This will move the withdrawal to the next approval stage or release funds.": "Hii itapeleka uondoaji kwenye hatua inayofuata ya idhini au kutoa pesa.",
      "This action will reject the withdrawal request.": "Hatua hii itakataa ombi la uondoaji.",
      "Withdrawal request has been approved.": "Ombi la uondoaji limeidhinishwa.",
      "Withdrawal request has been rejected.": "Ombi la uondoaji limekataliwa.",
      "Program now pending approval from the Chairperson.": "Programu sasa inasubiri idhini kutoka kwa Mwenyekiti.",
      "Pending Chair Approval": "Inasubiri Idhini ya Mwenyekiti",
      "Pending Secretary Approval": "Inasubiri Idhini ya Katibu",
      "Pending Accountant Approval": "Inasubiri Idhini ya Mhasibu",
      "Closed (Target Reached)": "Imefungwa (Lengo Limefikiwa)",
      "Closed (Time Ended)": "Imefungwa (Muda Umeisha)",
      "Not Requested": "Haijaombwa",
      "Withdrawal Rejected": "Uondoaji Umekataliwa",
      "Funds Released": "Pesa Zimetolewa",
      "Total Programs": "Jumla ya Programu",
      "Member Invoices & Payments": "Ankara za Wanachama & Malipo",
      "Each member has a unique reference number for this program.": "Kila mwanachama ana namba ya kumbukumbu ya kipekee kwa programu hii.",
      "Base Amount": "Kiasi cha Msingi",
      "DF": "SSC",
      "SSC": "SSC",
      "Total Due": "Jumla Inayadaiwa",
      "Paid": "Imelipwa",
      "No invoices loaded in this demo. In real system, all participants would appear here.": "Hakuna ankara zilizopakiwa katika onyesho hili. Katika mfumo halisi, washiriki wote wataonekana hapa.",
      "All contributions, DF, approvals and withdrawals for this program will appear in both member statements and program audit logs to comply with SACCOs & microfinance governance standards.": "Michango yote, SSC, idhini na uondoaji kwa programu hii itaonekana katika taarifa za wanachama na kumbukumbu za ukaguzi wa programu ili kuzingatia viwango vya utawala vya SACCOS na mikopo midogo.",
      "All contributions, SSC, approvals and withdrawals for this program will appear in both member statements and program audit logs to comply with SACCOs & microfinance governance standards.": "Michango yote, SSC, idhini na uondoaji kwa programu hii itaonekana katika taarifa za wanachama na kumbukumbu za ukaguzi wa programu ili kuzingatia viwango vya utawala vya SACCOS na mikopo midogo.",
      "Approve Program": "Idhinisha Programu",
      "Reject Program": "Kataa Programu",
      "Request Withdrawal": "Omba Uondoaji",
      "Withdrawal Request Details": "Maelezo ya Ombi la Uondoaji",
      "Beneficiary": "Mfaidika",
      "Account": "Akaunti",
      "Amount": "Kiasi",
      "Purpose": "Kusudi",
      "Rejection Reason": "Sababu ya Kukataa",
      "Status:": "Hali:",
      "Approval Chain": "Mlolongo wa Idhini",
      "Chair: Pending": "Mwenyekiti: Inasubiri",
      "Chair: Approved": "Mwenyekiti: Imeidhinishwa",
      "Secretary: Pending": "Katibu: Inasubiri",
      "Secretary: Approved": "Katibu: Imeidhinishwa",
      "Accountant: Pending": "Mhasibu: Inasubiri",
      "Accountant: Approved": "Mhasibu: Imeidhinishwa",
      "No withdrawal details to display.": "Hakuna maelezo ya uondoaji ya kuonyesha.",
      "Start Date": "Tarehe ya Kuanza",
      "End Date": "Tarehe ya Kumaliza",
      "Collected so far": "Zilizokusanywa kufikia sasa",
      "Program-level goal": "Lengo la kiwango cha programu",
      "of target": "ya lengo",


      // Entry Fee Invoices
      "Entry Fee Invoices": "Ankara za Kiingilio",
      "Track all group entry fee payments and their current status": "Fuatilia malipo yote ya viingilio vya vikundi na hali zake",
      "Search by invoice, member or group...": "Tafuta namba ya ankara, mwanachama au kundi...",
      "Filter Status": "Chuja Hali",
      "Export Report": "Pakua Ripoti",
      "Exporting...": "Inapakua...",
      "Refresh": "Onyesha upya",
      "All Entry Fee Invoices": "Ankara Zote za Viingilio",
      "Invoice No": "Namba ya Ankara",
      "Member": "Mwanachama",
      "Amount": "Kiasi",
      "No invoices found.": "Hakuna ankara zilizopatikana.",
      "Failed to load entry fee invoices.": "Imeshindwa kupakia ankara za viingilio.",
      "Failed to export invoices.": "Imeshindwa kupakua ankara.",
      "View": "Tazama",
      "PAID": "IMELIPWA",
      "PENDING": "INASUBIRI",
      "FAILED": "IMESHINDWA",
      "Assign members and register heirs for your group.": "Sajili wanachama na warithi wao katika kikundi chako.",
      "Search by name, email, or role...": "Tafuta kwa jina, barua pepe, au nafasi...",
      "Name": "Jina",
      "Email": "Barua pepe",
      "Role": "Nafasi",
      "Add Member": "Ongeza Mwanachama",
      "Phone": "Simu",
      "Slots": "Majina",
      "Payment Ref": "Marejeleo ya Malipo",
      'Heir': 'Mrithi',
      'Heirs': 'Warithi',
      "Add New Member": "Ongeza Mwanachama Mpya",
      "Member Information": "Taarifa za Mwanachama",
      "Mrithi (Heir) Details — *required*": "Maelezo ya Mrithi — *inahitajika*",
      "Save": "hifadhi",
      "Cancel": "ghairi",
      "Your Payment Reference": "Namba Ya Kufanyia Malipo",
      "Use this unique reference for all NMB bank payments.": "Tumia marejeleo haya ya kipekee kwa malipo yote ya benki ya NMB.",
      "Group Contribution Terms": "Masharti ya Michango ya Kundi",
      "Monthly": "Kila mwezi",
      "Current Balance": "Salio la Sasa",
      "Overpayment": "Zilizolipwa Zaidi",
      "Prepaid Periods": "Vipindi Vilivyolipiwa Mapema",
      "Next Due": "Malipo yanaofuata",
      "Contribution History": "Historia ya Michango",
      "CONTRIBUTION": "MICHANGO",
      "EMERGENCY_DEDUCTION": "MAKATO YA DHARURA",
      "SPECIAL_CONTRIBUTION": "MICHANGO MAALUM",
      "DIVIDEND_PAYOUT": "MGAAO",
      "Copied!": "Imenakiliwa!",
      "Balance After": "Salio Baada ya",
      "Timestamp": "Muda wa Kurekodi",
      "Type": "Aina",
      "Description": "Maelezo",
      "All Caught Up!": "Umekamilisha!",
      "You have no pending arrears invoices at the moment.": "Huna ankara zozote za madeni ya Fidia kwa sasa.",
      "Arrears Management": "Usimamizi wa Madeni ya Fidia",
      "Failed to load data": "Imeshindwa kupakia taarifa",
      "Generate arrears invoices from members list, and track invoice lifecycle.": "Tengeneza ankara za madeni kutoka kwenye orodha ya wanachama na fuatilia hatua zake.",
      "Group Members": "Wanachama wa Kundi",
      "Search member name or phone": "Tafuta jina au simu ya mwanachama",
      "Reset filters": "Rudisha vichujio",
      "Export": "Pakua",
      "Loading members...": "Inapakia wanachama...",
      "Error: {{message}}": "Hitilafu: {{message}}",
      "No members match your filters.": "Hakuna wanachama wanaolingana na vichujio vyako.",
      "Arrears Invoices": "Ankara za Madeni",
      "Search invoice no. or member": "Tafuta namba ya ankara au mwanachama",
      "Loading invoices...": "Inapakia ankara...",
      "No invoices match your filters.": "Hakuna ankara zinazolingana na vichujio vyako.",
      "Invoice": "Ankara",
      "Invoice Details": "Maelezo ya Ankara",
      "Invoice ID": "Namba ya Ankara",
      "Invoice ID:": "Namba ya Ankara:",
      "Member:": "Mwanachama:",
      "Status:": "Hali:",
      "Missed Periods": "Vipindi Vilivyokosekana",
      "Missed Periods:": "Vipindi Vilivyokosekana:",
      "Missed": "Vilivyokosekana",
      "Last Paid": "Mara ya Mwisho Kulipwa",
      "Total (TZS)": "Jumla (TZS)",
      "Total Due:": "Kiasi Kinachotakiwa:",
      "Created": "Imeundwa",
      "Created:": "Imeundwa:",
      "View": "Tazama",
      "Audit Trail": "Rekodi ya Ukaguzi",
      "Created by Chairperson at {{date}}": "Imeundwa na Mwenyekiti tarehe {{date}}",
      "Close": "Funga",
      "All": "Zote",
      "ACTIVE": "INAENDELEA",
      "SUSPENDED": "IMESITISHWA",
      "PENDING": "INASUBIRI",
      "PAID": "IMELIPWA",
      "EXPIRED": "IMEKWISHA",
      "My Emergency Contributions": "Michango Yangu ya Dharura",
      "View all emergency deductions and pending invoices.": "Tazama makato yote ya dharura na ankara zinazosubiri.",
      "Emergency Deductions": "Makato ya Dharura",
      "Emergency Invoices": "Ankara za Dharura",
      "Search event name or reference...": "Tafuta jina la tukio au kumbukumbu...",
      "Deduction Type": "Aina ya Makato",
      "Event": "Tukio",
      "Event Name": "Jina la Tukio",
      "Event Deduction": "Makato ya Tukio",
      "Deduction": "Makato",
      "From Overpayment": "Kutoka kwenye Malipo Zaidi",
      "From Balance": "Kutoka kwenye Salio",
      "From Main Balance": "Kutoka kwenye Salio Kuu",
      "From": "Kutoka",
      "To": "Hadi",
      "Date": "Tarehe",
      "Your Debt": "Deni Lako",
      "DF Amount": "Kiasi cha SSC",
      "DF Amount:": "Kiasi cha SSC:",
      "SSC Amount": "Kiasi cha SSC",
      "SSC Amount:": "Kiasi cha SSC:",
      "Total To Pay": "Jumla ya Kulipa",
      "Reference": "Marejeleo",
      "Issued At": "Iliyotolewa",
      "No emergency deductions found.": "Hakuna makato ya dharura yaliyopatikana.",
      "No invoices.": "Hakuna ankara.",
      "Arrears Management": "Usimamizi wa Madeni ya Fidia",
      // Group Businesses page
      "Group Businesses": "Biashara za Kundi",
      "Register, approve, and manage group-owned business income.": "Sajili, idhinisha na simamia mapato ya biashara za kundi.",
      "Active Businesses": "Biashara Zinazoendelea",
      "Pending Admin Approval": "Zinasubiri Uidhinisho wa Admin",
      "Pending Invoices": "Ankara Zinazosubiri",
      "Total Business Income": "Jumla ya Mapato ya Biashara",
      "Business Overview": "Muhtasari wa Biashara",
      "Register New Business": "Sajili Biashara Mpya",
      "Business List": "Orodha ya Biashara",
      "Invoices For My Action": "Ankara za Hatua Yangu",
      "Business": "Biashara",
      "Business Name": "Jina la Biashara",
      "Business Type": "Aina ya Biashara",
      "Register Group Business": "Sajili Biashara ya Kundi",
      "Active": "Inaendelea",
      "Pending Admin": "Inasubiri Admin",
      "Rejected": "Imekataliwa",
      "Created": "Imeundwa",
      "View Details": "Tazama Maelezo",
      "Approve Business": "Idhinisha Biashara",
      "No businesses registered yet.": "Hakuna biashara zilizosasajiliwa bado.",
      "My Action": "Hatua Yangu",
      "Download": "Pakua",
      "Approve": "Idhinisha",
      "Pending": "Inasubiri",
      "Payment Ref": "Marejeleo ya Malipo",
      "Customer": "Mteja",
      "Contact": "Mawasiliano",
      "Items": "Vitu",
      "Subtotal": "Jumla Ndogo",
      "Amount To Pay": "Kiasi cha Kulipa",
      "Paid": "Imelipwa",
      "Payment Status": "Hali ya Malipo",
      "Chain": "Mfululizo",
      "No invoices found.": "Hakuna ankara zilizopatikana.",
      "Unknown Business": "Biashara Isiyojulikana",
      "Download Invoice PDF": "Pakua Ankara ya PDF",
      "Pending approvals": "Inasubiri uidhinisho",
      "Action": "Kitendo",
      "By": "Kwa",
      "At": "Wakati",
      "Invoices": "Ankara",
      "Audit Trail": "Kumbukumbu ya Ukaguzi",
      "New Invoice": "Ankara Mpya",
      "No invoices yet.": "Hakuna ankara bado.",
      "Item count label": "Vitu {{count}}",
      "Line Items": "Vitu vya Ankara",
      "Add Item": "Ongeza Kipengee",
      "Item {{index}} Description": "Maelezo ya Kipengee {{index}}",
      "Quantity": "Idadi",
      "Unit Price (TZS)": "Bei kwa Kimoja (TZS)",
      "Line Total": "Jumla ya Mstari",
      "Remove item": "Ondoa kipengee",
      "Service Amount (TZS)": "Kiasi cha Huduma (TZS)",
      "Sum of all line item totals": "Jumla ya viwango vya mistari yote",
      "Invoice Payment Reference": "Marejeleo ya Malipo ya Ankara",
      "Copy reference": "Nakili marejeleo",
      "Share this reference with customers at the bank to ensure matching payments.": "Shiriki marejeleo haya na wateja benki ili kulinganisha malipo.",
      "Summary": "Muhtasari",
      "Payment Reference: {{ref}}": "Marejeleo ya Malipo: {{ref}}",
      "Summary line": "{{index}}. {{description}} — {{quantity}} × {{unit}} TZS = {{total}} TZS",
      "Summary totals": "Jumla ndogo: {{subtotal}} TZS | SSC ({{percent}}%): {{fee}} TZS | Jumla: {{total}} TZS",
      "Special note: OF is retained automatically. Customer should pay the total amount shown above.": "Tahadhari: SSC inakatwa moja kwa moja. Mteja anapaswa kulipa jumla iliyoonyeshwa hapo juu.",
      "Special note: SSC is retained automatically. Customer should pay the total amount shown above.": "Tahadhari: SSC inakatwa moja kwa moja. Mteja anapaswa kulipa jumla iliyoonyeshwa hapo juu.",
      "Muhasibu approval note": "Uthibitisho wa Muhasibu hauleti fedha moja kwa moja—fedha huingia benki na mfumo huonyesha baada ya malipo kunaswa.",
      "Send for Approval": "Tuma kwa Uidhinisho",
      "{{name}} — Details": "{{name}} — Maelezo",
      "Total Income": "Jumla ya Mapato",
      "Customer Name": "Jina la Mteja",
      "Customer Phone": "Simu ya Mteja",
      "Customer Address": "Anuani ya Mteja",
      "Invoice Date": "Tarehe ya Ankara",
      "Description (Service Rendered)": "Maelezo (Huduma Iliyotolewa)",
      "Service": "Huduma",
      "Rental": "Kodi",
      "Product Sales": "Uuzaji wa Bidhaa",
      "Other": "Nyingine",
      "Starting Capital (TZS)": "Mtaji wa Mwanzo (TZS)",
      "Submit (Admin Approval)": "Wasilisha (Inahitaji Admin)",
      "Reference copied": "Marejeleo yamenakiliwa",
      "Copy failed": "Imeshindwa kunakili",
      "Please copy the reference manually.": "Tafadhali nakili marejeleo mwenyewe.",
      "Copy not supported": "Kunakili hakusaidiwi",
      "Select and copy the reference manually.": "Chagua na unakili marejeleo mwenyewe.",
      "Customer name is required": "Jina la mteja linahitajika",
      "Customer phone is required": "Simu ya mteja inahitajika",
      "Customer address is required": "Anuani ya mteja inahitajika",
      "Description is required": "Maelezo yanahitajika",
      "Quantity must be greater than 0": "Idadi lazima iwe zaidi ya 0",
      "Unit price must be greater than 0": "Bei ya kipengee lazima iwe zaidi ya 0",
      "Add at least one valid line item.": "Ongeza angalau kipengee kimoja halali.",
      "Please fix the highlighted line items.": "Tafadhali rekebisha vipengee vilivyoangaziwa.",
      "Please fix the highlighted fields.": "Tafadhali rekebisha sehemu zilizoangaziwa.",
      "Create Invoice — {{name}}": "Tengeneza Ankara — {{name}}",
      "No line items captured.": "Hakuna vitu vilivyorekodiwa.",
      "Item": "Kipengee",
      "Line item tooltip": "{{index}}. {{description}} ({{quantity}} × {{unit}} TZS = {{total}} TZS)",
      "Payment due label": "{{label}} ({{amount}} TZS inahitajika)",
      "Pending Katibu": "Inasubiri Katibu",
      "Pending Muhasibu": "Inasubiri Muhasibu",
      "Approved (bank capture pending)": "Imeidhinishwa (inasubiri ushahidi wa benki)",
      "Draft": "Rasimu",
      "Awaiting approval": "Inasubiri uidhinisho",
      "Awaiting payment": "Inasubiri malipo",
      "Partially paid": "Imelipwa sehemu",
      "Overdue": "Imechelewa",
      "Paid in full": "Imelipwa kikamilifu",
      "Awaiting payment data": "Inasubiri taarifa za malipo",
      "Chair ✓ → Katibu": "Mwenyekiti ✓ → Katibu",
      "Katibu ✓ → Muhasibu": "Katibu ✓ → Muhasibu",
      "Muhasibu ✓ (Approved, await bank credit)": "Muhasibu ✓ (Imeidhinishwa, subiri mkopo wa benki)",
      "Submitted for Admin approval": "Imewasilishwa kwa uidhinisho wa Admin",
      "Registration Failed": "Usajili Umeshindikana",
      "Invoice sent to Katibu": "Ankara imetumwa kwa Katibu",
      "Invoice Creation Failed": "Uundaji wa Ankara Umeshindikana",
      "Approve Business?": "Idhinishe Biashara?",
      "Activate \"{{name}}\"": "Washa \"{{name}}\"",
      "Business approved": "Biashara imeidhinishwa",
      "Approval Failed": "Uidhinisho Umeshindikana",
      "Approved → Muhasibu": "Imeidhinishwa → Muhasibu",
      "Approved (awaiting bank payment capture)": "Imeidhinishwa (inasubiri uthibitisho wa malipo ya benki)",
      "Download Failed": "Kupakua kumeshindikana",
      "Missing fields": "Sehemu zimekosekana",
      "Name, Type, and Capital are required.": "Jina, Aina na Mtaji vinahitajika.",
      // Special Contribution Programs
      "Special Contribution Programs": "Programu za Michango Maalum",
      "Monitor program progress, member payments, and handle withdrawals with proper approval chain.": "Fatilia maendeleo ya programu, malipo ya wanachama na simamia utoaji kwa mnyororo sahihi wa uidhinishaji.",
      "All Programs": "Programu Zote",
      "My Programs": "Programu Zangu",
      "Search program or leader...": "Tafuta programu au kiongozi...",
      "Start Program": "Anza Programu",
      "Total Programs": "Jumla ya Programu",
      "Active Programs": "Programu Zinazoendelea",
      "Closed & Ready for Withdrawal": "Zimefungwa na ziko tayari kwa utoaji",
      "Programs": "Programu",
      "Program": "Programu",
      "Leader": "Kiongozi",
      "Progress": "Maendeleo",
      "Status based on target amount & timeframe closure.": "Hali inategemea kiwango cha lengo na ukomo wa muda.",
      "No programs found.": "Hakuna programu zilizopatikana.",
      "Closed (Target Reached)": "Imefungwa (Lengo Limefikiwa)",
      "Closed (Time Ended)": "Imefungwa (Muda Umeisha)",
      "Pending Chair Approval": "Inasubiri Mwenyekiti",
      "Pending Secretary Approval": "Inasubiri Katibu",
      "Pending Accountant Approval": "Inasubiri Muhasibu",
      "Not Requested": "Haijaombwa",
      "Funds Released": "Fedha Zimetolewa",
      "Withdrawal Rejected": "Utoaji Umekataliwa",
      "Failed to load programs": "Imeshindwa kupakia programu",
      "Could not load members": "Imeshindwa kupakia wanachama",
      "Initiator inactive": "Mwananzilishi si hai",
      "Only active members can initiate a program.": "Ni wanachama hai pekee wanaoweza kuanzisha programu.",
      "Missing Title": "Kichwa kimekosekana",
      "Please enter a program title.": "Tafadhali weka kichwa cha programu.",
      "Invalid Target": "Lengo si sahihi",
      "Target per member must be greater than zero.": "Lengo kwa kila mwanachama lazima liwe zaidi ya sifuri.",
      "Missing Dates": "Tarehe zimekosekana",
      "Please select start and end dates.": "Tafadhali chagua tarehe ya kuanza na kumaliza.",
      "Invalid Timeframe": "Muda si sahihi",
      "End date must be after start date.": "Tarehe ya mwisho lazima iwe baada ya tarehe ya kuanza.",
      "No Participants": "Hakuna washiriki",
      "Select at least one active participant.": "Chagua angalau mshiriki mmoja aliye hai.",
      "Creation Failed": "Uundaji Umekwama",
      "Program Created": "Programu Imeundwa",
      "Title:": "Kichwa:",
      "Leader:": "Kiongozi:",
      "Participants (active):": "Washiriki (hai):",
      "Target/Member:": "Lengo/Kila Mwanachama:",
      "Total Target:": "Jumla ya Lengo:",
      "Program now pending approval from the Chairperson.": "Programu inasubiri uidhinisho wa Mwenyekiti.",
      "Program still active": "Programu bado inaendelea",
      "Withdrawal can only be initiated after the program closes.": "Utoaji unaweza kuombwa tu baada ya programu kufungwa.",
      "Request Already Exists": "Ombi lipo tayari",
      "Withdrawal request exists status": "Ombi la utoaji tayari lipo na hali yake ni: {{status}}.",
      "Request Withdrawal?": "Kuomba Utoaji?",
      "Enter beneficiary details for the withdrawable amount of {{amount}} TZS.": "Weka maelezo ya mnufaika kwa kiasi cha kufidiwa cha {{amount}} TZS.",
      "Beneficiary Name": "Jina la Mnufaika",
      "Beneficiary Account (Bank/Mobile)": "Akaunti ya Mnufaika (Benki/Simu)",
      "Purpose of withdrawal (optional)": "Sababu ya utoaji (hiari)",
      "Submit Request": "Tuma Ombi",
      "Beneficiary name and account are required.": "Jina na akaunti ya mnufaika vinahitajika.",
      "Withdrawal Request Sent!": "Ombi la Utoaji limetumwa!",
      "Withdrawal pending chairperson": "Ombi linasubiri uidhinisho wa Mwenyekiti.",
      "Request Failed": "Ombi limekosa",
      "Status:": "Hali:",
      // Member Dividends
      "My Dividends": "Mgao Wangu",
      "Track your personal dividend receipts with bank-grade transparency.": "Fuatilia malipo yako ya mgao kwa uwazi wa kiwango cha benki.",
      "Refresh": "Onyesha upya",
      "Total dividends received": "Jumla ya mgao uliopokelewa",
      "Last distribution": "Mgao wa mwisho",
      "Largest single payout": "Malipo makubwa zaidi",
      "Pending": "Inasubiri",
      "Payout History": "Historia ya Malipo",
      "Search description or period...": "Tafuta maelezo au kipindi...",
      "From": "Kutoka",
      "To": "Hadi",
      "Target Type": "Aina ya walengwa",
      "All Runs": "Mizunguko Yote",
      "Active Members": "Wanachama Hai",
      "Borrowers": "Wakopaji",
      "Period": "Kipindi",
      "Target": "Walengwa",
      "Description": "Maelezo",
      "Amount": "Kiasi",
      "Dividend distribution": "Mgao wa hisa",
      "Posted on {{date}}": "Imewekwa {{date}}",
      "Latest Activity": "Shughuli za Hivi Karibuni",
      "Credited on {{date}}": "Imewekwa {{date}}",
      "No dividend payouts yet": "Hakuna malipo ya mgao bado",
      "Your dividend earnings will appear here right after the next group distribution.": "Mapato yako ya mgao yataonekana hapa mara tu baada ya mgao unaofuata wa kikundi.",
      // Transactions Audit
      "Transactions & Audit": "Muamala na Ukaguzi",
      "Unified financial view — Member Statements & Program Audit Logs": "Mtazamo mmoja wa kifedha — Taarifa za Wanachama na Kumbukumbu za Ukaguzi wa Programu",
      "Retry": "Jaribu tena",
      "Member Statement": "Taarifa ya Mwanachama",
      "Program Audit Log": "Kumbukumbu ya Ukaguzi wa Programu",
      "Search text (member, notes, action)": "Tafuta maandishi (mwanachama, maelezo, kitendo)",
      "Refresh Data": "Onyesha data upya",
      "Export CSV (Statement)": "Pakua CSV (Taarifa)",
      "Export CSV (Audit)": "Pakua CSV (Ukaguzi)",
      "Loading latest records...": "Inapakia rekodi za karibuni...",
      "Amount (TZS)": "Kiasi (TZS)",
      "Overpayment (TZS)": "Malipo kupita kiasi (TZS)",
      "Balance After (TZS)": "Salio Baada (TZS)",
      "No transactions match your filters.": "Hakuna muamala unaolingana na vichujio vyako.",
      "Amount Per Member (TZS)": "Kiasi kwa Mwanachama (TZS)",
      "Initiated By": "Imeanzishwa na",
      "No audit entries match your filters.": "Hakuna kumbukumbu za ukaguzi zinazolingana na vichujio vyako.",
      "Failed to load transaction audit data.": "Imeshindwa kupakia data ya ukaguzi wa miamala.",
      "Contribution": "Mchango",
      "Penalty": "Adhabu",
      "Loan Disbursement": "Utoaji wa Mkopo",
      "Loan Repayment": "Malipo ya Mkopo",
      "Withdrawal": "Kutoa",
      "Adjustment": "Marekebisho",
      "Emergency Deduction": "Makato ya Dharura",
      "Business Income": "Mapato ya Biashara",
      "Dividend Payout": "Mgao",
      "Dividend Bank Charge": "Ada ya Benki ya Mgao",
      "Loan Interest Income": "Mapato ya Riba ya Mkopo",
      "Defaults Collected": "Madai yaliyokusanywa",
      // Leader Withdrawal Approvals
      "Member Withdrawal Approvals": "Uidhinishaji wa Uondoaji wa Wanachama",
      "Workflow: Mwenyekiti → Katibu → Muhasibu. Financial clearance is verified before the final payout.": "Mtiririko: Mwenyekiti → Katibu → Muhasibu. Uthibitisho wa kifedha hufanyika kabla ya malipo ya mwisho.",
      "Refresh": "Onyesha upya",
      "Refreshing...": "Inasasisha...",
      "Waiting for Mwenyekiti": "Inasubiri Mwenyekiti",
      "Waiting for Katibu": "Inasubiri Katibu",
      "Waiting for Muhasibu": "Inasubiri Muhasibu",
      "Finalized": "Imekamilika",
      "Double-entry ledger entries and retention/refund calculations are created automatically after Muhasibu approval. Once finalized, the member becomes inactive and only reactivates when the group reinstates them.": "Kumbukumbu za uhasibu na mahesabu ya makato marejesho huundwa moja kwa moja baada ya uidhinisho wa Muhasibu. Baada ya kukamilika mwanachama husitishwa hadi kikundi kitakaporejesha uanachama.",
      "Search by member name or reason...": "Tafuta kwa jina au sababu...",
      "All Statuses": "Hali Zote",
      "Approvals": "Uidhinisho",
      "Actions": "Vitendo",
      "Reason": "Sababu",
      "Submitted": "Imewasilishwa",
      "No withdrawal requests match your filters.": "Hakuna maombi ya uondoaji yanayolingana na vichujio vyako.",
      "View full details": "Tazama maelezo kamili",
      "Approve & move to the next stage": "Idhinisha na uende kwenye hatua inayofuata",
      "Approve disabled tooltip": "Unaweza kuidhinisha tu maombi yanayosubiri nafasi yako.",
      "Reject request": "Kataa ombi",
      "Reject disabled tooltip": "Unaweza kukataa tu maombi yanayosubiri nafasi yako.",
      "Approval pending label": "{{role}}: Inasubiri",
      "Withdrawal Request Details": "Maelezo ya Ombi la Uondoaji",
      "Rejected: {{reason}}": "Imekataliwa: {{reason}}",
      "Submitted on": "Imewasilishwa tarehe",
      "Reason for withdrawal": "Sababu ya uondoaji",
      "Retention Percent": "Asilimia ya Kiasi Kinachozuiliwa",
      "Retention Amount": "Kiasi Kilichozuiliwa",
      "Refund Amount": "Kiasi cha Kurudishiwa",
      "Approval progress": "Maendeleo ya Uidhinishaji",
      "Approval trail": "Historia ya Uidhinishaji",
      "Mwenyekiti": "Mwenyekiti",
      "Katibu": "Katibu",
      "Muhasibu": "Muhasibu",
      "Approved by {{name}} on {{date}}": "Imeidhinishwa na {{name}} tarehe {{date}}",
      "Awaiting action": "Inasubiri hatua",
      "Close": "Funga",
      "Withdrawal approvals are only accessible to the Mwenyekiti, Katibu and Muhasibu roles.": "Uidhinishaji wa uondoaji unapatikana kwa Mwenyekiti, Katibu na Muhasibu pekee.",
      "Unable to load withdrawal requests.": "Imeshindwa kupakia maombi ya uondoaji.",
      "Approve withdrawal request?": "Idhinishe ombi la uondoaji?",
      "Approve withdrawal text": "Hili litasogeza ombi la {{member}} kwenda hatua inayofuata ya uidhinishaji.",
      "Yes, proceed": "Ndiyo, endelea",
      "Action recorded": "Hatua imerekodiwa",
      "Workflow moved to next approver": "Mtiririko umehamia kwa mwidhinishaji anayefuata.",
      "Unable to approve": "Imeshindwa kuidhinisha",
      "Please try again.": "Tafadhali jaribu tena.",
      "Reject withdrawal?": "Ukatae ombi la uondoaji?",
      "Reject withdrawal note": "Tafadhali weka ufafanuzi mfupi kwa kumbukumbu ya ukaguzi.",
      "Rejection reason": "Sababu ya kukataa",
      "Rejection reason placeholder": "mf. Mwanachama bado ana deni la mkopo",
      "Rejection reason is required.": "Sababu ya kukataa inahitajika.",
      "Reject": "Kataa",
      "Request rejected": "Ombi limekataliwa",
      "Member notified": "{{member}} amearifiwa kuhusu uamuzi.",
      "Unable to reject": "Imeshindwa kukataa",
      "Member Invoices & Payments": "Ankara na Malipo ya Mwanachama",
      "Total groups": "Jumla ya vikundi",

































































































































































































































































































































































































































































































































































































































































































































































































































































      // System Settings
      "System Settings": "Mipangilio ya Mfumo",
      // General Report
      "Generate Report": "Tengeneza Ripoti",
      "Report Summary": "Muhtasari wa Ripoti",
      "Start Date": "Tarehe ya Kuanza",
      "End Date": "Tarehe ya Kumaliza",
      "Branch": "Tawi",
      "All Branches": "Matawi Yote",
      "Total Insurance Amount": "Jumla ya Bima",
      "Total Registration Payment": "Jumla ya Malipo ya Usajili",
      "Total Visiting Payment": "Jumla ya Malipo ya Kutembelea",
      "Total Penalties": "Jumla ya Adhabu",
      "Total Expenses": "Jumla ya Matumizi",
      "Total Loans Disbursed": "Jumla ya Mikopo Iliyotolewa",
      "Total Collections": "Jumla ya Makusanyo",
      "Total Repayments": "Jumla ya Marejesho",
      "Exceeded Amount": "Kiasi Kilichozidi",
      "Start date is required": "Tarehe ya kuanza inahitajika",
      "End date is required": "Tarehe ya kumaliza inahitajika",
      // Loan Report
      "Loans Report": "Ripoti ya Mikopo",
      "Search loan or member": "Tafuta mkopo au mwanachama",
      "Are you sure you want to Approve this Loan?": "Je, una uhakika unataka Kuidhinisha Mkopo huu?",
      "Loan successfully approved": "Mkopo umemeidhinishwa kikamilifu",
      "Unauthorized": "Hairuhusiwi",
      "You are not authorized to approve loans": "Huna idhini ya kuidhinisha mikopo",
      "Customer": "Mteja",
      "Category": "Kundi",
      "Amount": "Kiasi",
      "Repayment": "Marejesho",
      "StartDate": "Tarehe ya Kuanza",
      "EndDate": "Tarehe ya Kumaliza",
      "Action": "Kitendo",
      "Full paid": "imelipwa kikamilifu",
      "Not paid at all": "Hijalipwa kabisa",
      "Under paid": "Imelipwa kidogo",
      "Repayments": "Marejesho",
      "Repayments schedule": "Ratiba ya marejesho",
      "Schedule": "Ratiba",
      "Network Problem.Please check your Internet": "Tatizo la Mtandao. Tafadhali angalia Intaneti yako",
      "Previous": "Kabla",
      "Next": "Ijayo",
      // Reportes
      "Financial Reports": "Ripoti za Fedha",
      "Income Statement": "Taarifa ya Mapato",
      "Profit/Loss Trend": "Mwenendo wa Faida/Hasara",
      "Type": "Aina",
      "Interval": "Interval",
      "Income statement": "Taarifa ya Mapato",
      "daily": "Kila Siku",
      "Quarterly": "Robo mwaka",
      "Yearly": "Kila Mwaka",
      "From": "Kuanzia",
      "To": "Mpaka",
      "GENERATE": "TENGENEZA",
      "ITEM": "KITU",
      "AMOUNT": "KIASI",
      "Purchases": "Manunuzi",
      "Returned Purchases": "Manunuzi Yaliyorejeshwa",
      "Sales": "Mauzo",
      "Returned Sales": "Mauzo Yaliyorejeshwa",
      "Expenses": "Matumizi",
      "Wastages": "Uharibifu",
      "Profit/Loss": "Faida/Hasara",
      // Reports Pages
      "From": "Kuanzia",
      "To": "Mpaka",
      "Group": "Kundi",
      "Loading groups...": "Inapakia vikundi...",
      "Error loading groups": "Hitilafu kupakia vikundi",
      "No groups found": "Hakuna vikundi vilivyopatikana",
      "Member": "Mwanachama",
      "Loading members...": "Inapakia wanachama...",
      "Error loading members": "Hitilafu kupakia wanachama",
      "Select a group first": "Chagua kikundi kwanza",
      "Generate": "Tengeneza",
      "Generating...": "Inatengeneza...",
      "Export as PDF": "Hamisha kama PDF",
      "Export as Excel": "Hamisha kama Excel",
      "Failed to load groups.": "Imeshindwa kupakia vikundi.",
      "Failed to load members.": "Imeshindwa kupakia wanachama.",
      // AuditComplianceReport
      "Audit & Compliance Report": "Ripoti ya Ukaguzi wa Mifumo",
      "Trace all system actions for regulatory and internal audit requirements.": "Fuatilia vitendo vyote vya mfumo kwa mahitaji ya ukaguzi na udhibiti.",
      "Access: Admin only (or as per policy)": "Ufikiaji: Admin pekee (au kulingana na sera)",
      "Audit Trail": "Mwenendo wa Ukaguzi",
      "Date & Time": "Tarehe & Muda",
      "User": "Mtumiaji",
      "Details": "Maelezo",
      "No matching audit events for the selected filters.": "Hakuna matukio ya ukaguzi yanayoendana na vichungi vilivyochaguliwa.",
      "Loading report...": "Inapakia ripoti...",
      "Please select filters and click \"Generate\" to view the report.": "Tafadhali chagua vichungi na ubonyeze \"Tengeneza\" kuona ripoti.",
      "User / Action Search": "Tafuta Mtumiaji / Kitendo",
      "Export logic not yet implemented.": "Utaratibu wa kuhamisha haujatekelezwa bado.",
      "Info": "Taarifa",
      // GroupLiquidityReport
      "Group Liquidity Position": "Hali ya Ukwasi wa Kikundi",
      "Cash availability versus outstanding loan obligations.": "Upatikanaji wa fedha dhidi ya madeni ya mikopo ambayo hayajalipwa.",
      "Access: Chairperson / Secretary / Accountant / Admin / Desk Officer": "Ufikiaji: Mwenyekiti / Katibu / Mhasibu / Admin/ Afisa wa Dawati",
      "Cash on Hand": "Fedha Taslimu Mkononi",
      "Group Bank Balance": "Salio la Benki ya Kikundi",
      "Liquidity Index": "Kipimo cha Ukwasi",
      "Higher is better. Below 50% is a risk signal.": "Juu ni bora. Chini ya 50% ni ishara ya hatari.",
      "Obligations vs Available Cash": "Madeni dhidi ya Fedha Zilizopo",
      "Obligations": "Madeni",
      "Outstanding Loans": "Mikopo Inayodaiwa",
      "Overdue Loans": "Mikopo Iliyocheleweshwa",
      "Expected Repayments (month)": "Marejesho Yanayotarajiwa (mwezi)",
      "Simple Liquidity Visual": "Muonekano wa Ukwasi Rahisi",
      "Integrate a proper chart (e.g. Recharts) later.": "Unganisha chati inayofaa (mf. Recharts) baadaye.",
      "Please select a group and click \"Generate\" to view the report.": "Tafadhali chagua kikundi na ubonyeze \"Tengeneza\" kuona ripoti.",
      "Please select a group to generate the report.": "Tafadhali chagua kikundi kutengeneza ripoti.",
      "Missing Filter": "Kichungi Kinakosekana",
      // MemberHealthScoreReport
      "Member Financial Health Score": "Alama ya Afya ya Kifedha ya Mwanachama",
      "Risk and reliability score per member based on repayments, arrears and penalties.": "Alama ya hatari na uaminifu kwa kila mwanachama kulingana na marejesho, malimbikizo na adhabu.",
      "Financial Health Overview": "Muhtasari wa Afya ya Kifedha",
      "Score derived from repayment history, arrears, contribution consistency, penalties and defaults.": "Alama inatokana na historia ya marejesho, malimbikizo, uthabiti wa michango, adhabu na kushindwa kulipa.",
      "Select a group to see all members, or select a specific member, then click \"Generate\".": "Chagua kikundi kuona wanachama wote, au chagua mwanachama maalum, kisha bonyeza \"Tengeneza\".",
      "Score": "Alama",
      "Arrears": "Malimbikizo",
      "Penalties": "Adhabu",
      "No health score data available for the selected member.": "Hakuna data ya alama ya afya inayopatikana kwa mwanachama aliyechaguliwa.",
      "Excellent": "Bora",
      "Good": "Nzuri",
      "Fair": "Wastani",
      // MonthlyGroupPerformanceReport
      "Monthly Group Performance": "Utendaji wa Kila Mwezi wa Kikundi",
      "Summary of contributions, loans, penalties and balances for the selected period.": "Muhtasari wa michango, mikopo, adhabu na salio kwa kipindi kilichochaguliwa.",
      "Missing Filters": "Vichungi Vinavyokosekana",
      "Please select a group and a date range to generate the report.": "Tafadhali chagua kikundi na tarehe ili kutoa ripoti.",
      "No Data": "Hakuna Data",
      "Please generate a report first before exporting.": "Tafadhali toa ripoti kwanza kabla ya kuhamisha.",
      "Export Failed": "Uhamishaji Umeshindwa",
      "Total Contributions": "Jumla ya Michango",
      "Total Income (Period)": "Jumla ya Mapato (Kipindi)",
      "Loan Disbursements": "Mikopo Iliyotolewa",
      "Group Balance": "Salio la Kikundi",
      "Member Level Performance": "Utendaji wa Ngazi ya Mwanachama",
      "Per-member summary for this period.": "Muhtasari wa kila mwanachama kwa kipindi hiki.",
      "Active": "Hai",
      "Inactive": "Haifanyi kazi",
      "Loans Disbursed": "Mikopo Iliyotolewa",
      // SystemGrowthMetricsReport
      "System Growth Metrics": "Vipimo vya Ukuaji wa Mfumo",
      "High level performance across all groups in the system.": "Utendaji wa kiwango cha juu katika vikundi vyote kwenye mfumo.",
      "Access: Admin / Desk Officer only": "Ufikiaji: Admin / Afisa wa Dawati pekee",
      "New Members": "Wanachama Wapya",
      "Member Exits": "Kuondoka kwa Wanachama",
      "Loans Issued": "Mikopo Iliyotolewa",
      "Loans Repaid": "Mikopo Iliyolipwa",
      "New Groups": "Vikundi Vipya",
      "Business Invoices": "Ankara za Biashara",
      "Visual Overview (Mock)": "Muonekano wa Visual (Kielelezo)",
      "Replace with real chart component later (Recharts/Chart.js)": "Badilisha na sehemu halisi ya chati baadaye (Recharts/Chart.js)",
      "max scale": "kiwango cha juu",
      "Donations": "Misaada",
      "Groups": "Vikundi",
      // LoanReportDialog & ReportPopup
      "Upload Contract": "Pakia Mkataba",
      "Use Description": "Tumia Maelezo",
      "Use Expire Date": "Tumia Tarehe ya Kuisha",
      "Use Bacth Number": "Tumia Namba ya Batch",
      "Use Category": "Tumia Kategoria",
      "Loan Category": "Kategoria ya Mkopo",
      "Repayment Method": "Njia ya Malipo",
      "Duration": "Muda",
      "Interest rate %": "Riba %",
      "Start date": "Tarehe ya Kuanza",
      "Entrepreneur": "Mjasiriamali",
      "Business": "Biashara",
      "Workers": "Wafanyakazi",
      "Daily": "Kila Siku",
      "Monthly": "Kila Mwezi",
      "Loan successful updated": "Mkopo umesasishwa kikamilifu",
      "Product added": "Bidhaa imeongezwa",
      "Product successful updated": "Bidhaa imesasishwa kikamilifu",
      "Product settings successful updated": "Mipangilio ya bidhaa imesasishwa kikamilifu",
      "Product successful deleted": "Bidhaa imefutwa kikamilifu",
      "Something went wrong": "Kuna kitu kimeenda vibaya",
      "Patient successful sent to Dr": "Mgonjwa ametumwa kwa Daktari kikamilifu",
      "Please select Dr": "Tafadhali chagua Daktari",
      "Please fill in the required fields": "Tafadhali jaza sehemu zinazohitajika",
      "Error occured": "Hitilafu imetokea",
      "BILLING INFO": "TAARIFA ZA MALIPO",
      "Purchases Total": "Jumla ya Manunuzi",
      "Returned Purchases Total": "Jumla ya Manunuzi Yaliyorejeshwa",
      "Sales Total": "Jumla ya Mauzo",
      "Returned Sales Total": "Jumla ya Mauzo Yaliyorejeshwa",
      "Expenses Total": "Jumla ya Matumizi",
      "Associated Costs Total": "Gharama Husika",
      "Quantity": "Kiasi",
      "Gender": "Jinsia",
      "Phone": "Simu",
      "RETURN": "REJESHA",
      "Report successful generated": "Ripoti imetengenezwa kikamilifu",
      "Sale successful returned": "Mauzo yamerejeshwa kikamilifu",
      "Sale successful deleted": "Mauzo yamefutwa kikamilifu",
      // User Profile
      "Waiting for Chairperson": "Inasubiri Mwenyekiti",
      "Waiting for Secretary": "Inasubiri Katibu",
      "Waiting for Accountant": "Inasubiri Muhasibu",
      "Completed": "Imekamilika",
      "Rejected": "Imekataliwa",
      "Chairperson": "Mwenyekiti",
      "Secretary": "Katibu",
      "Accountant": "Muhasibu",
      "Current password is required": "Nenosiri la sasa linahitajika",
      "New password is required": "Nenosiri jipya linahitajika",
      "Passwords do not match": "Manenosiri hayafanani",
      "Password successfully updated": "Nenosiri limesasishwa kikamilifu",
      "New Password Error": "Hitilafu ya Nenosiri Jipya",
      "Current Password Error": "Hitilafu ya Nenosiri la Sasa",
      "My Savvy Community Profile": "Wasifu Wangu wa Savvy Community",
      "Next of Kin (Heir)": "Mrithi",
      "Relationship": "Uhusiano",
      "Heir information not set. Please contact your group administrator.": "Taarifa za mrithi hazijawekwa. Tafadhali wasiliana na msimamizi wako wa kikundi.",
      "Membership Withdrawal Workflow": "Mchakato wa Kujitoa Uanachama",
      "Requests flow through Chairperson → Secretary → Accountant. Financial clearance is verified automatically before payout.": "Maombi yanapitia Mwenyekiti → Katibu → Muhasibu. Usafi wa kifedha unathibitishwa kiotomatiki kabla ya malipo.",
      "You already have a withdrawal request in progress.": "Tayari una ombi la kujitoa linashughulikiwa.",
      "Start a new withdrawal request": "Anzisha ombi jipya la kujitoa",
      "Financial clearance": "Usafi wa Kifedha",
      "You currently have no outstanding obligations.": "Kwa sasa hauna madeni yoyote.",
      "Please clear the following outstanding amounts before the request reaches the accountant:": "Tafadhali lipa kiasi kifuatacho kabla ombi halijamfikia muhasibu:",
      "Pending contributions": "Michango inayosubiriwa",
      "Retention percentage": "Asilimia ya kuzuia",
      "of your current savings": "ya akiba yako ya sasa",
      "remains with the group per policy": "inabaki na kikundi kulingana na sera",
      "Request submitted": "Ombi limetumwa",
      "Group leadership will now review your withdrawal request.": "Uongozi wa kikundi sasa utapitia ombi lako la kujitoa.",
      "Request details": "Maelezo ya ombi",
      "Your request was rejected. Please talk to the leadership team for the next steps.": "Ombi lako limekataliwa. Tafadhali zungumza na uongozi kwa hatua zinazofuata.",
      "Your request is moving through the approval chain.": "Ombi lako linaendelea kupitia mchakato wa idhini.",
      "Reason for withdrawal": "Sababu ya kujitoa",
      "Rejection details": "Maelezo ya kukataliwa",
      "Retention breakdown": "Mchanganuo wa kuzuia",
      "Amount retained by the group": "Kiasi kilichozuiwa na kikundi",
      "Refund issued to you": "Marejesho uliyopewa",
      "Finalized on": "Imekamilishwa tarehe",
      "Not approved yet": "Bado haijaidhinishwa",
      "Use the arrow icon above to submit a withdrawal request once you are confident about the figures shown here.": "Tumia aikoni ya mshale hapo juu kutuma ombi la kujitoa ukisharidhika na takwimu zilizooneshwa hapa.",
      "Security": "Usalama",
      "Current Password": "Nenosiri la Sasa",
      "New Password": "Nenosiri Jipya",
      "Confirm New Password": "Thibitisha Nenosiri Jipya",
      "Update Password": "Sasisha Nenosiri",
      "Submit Withdrawal Request": "Tuma Ombi la Kujitoa",
      "Share the reason you want to leave the group. Your explanation will be visible to the leadership team reviewing the request.": "Eleza sababu ya kutaka kuondoka kwenye kikundi. Maelezo yako yataonekana kwa uongozi unaopitia ombi.",
      "Explain briefly why you want to withdraw...": "Eleza kwa ufupi kwa nini unataka kujitoa...",
      "Once the Chairperson and Secretary approve, the system re-checks loans, penalties, and contributions before the Accountant releases the final payout.": "Ikishaidhinishwa na Mwenyekiti na Katibu, mfumo utakagua tena mikopo, adhabu, na michango kabla ya Muhasibu kutoa malipo ya mwisho.",
      "Unable to submit your request right now.": "Imeshindikana kutuma ombi lako kwa sasa.",
      "Please provide a brief reason for leaving.": "Tafadhali toa sababu fupi ya kuondoka.",
      "Configure core financial parameters. All changes are logged.": "Sanidi vigezo vya msingi vya kifedha. Mabadiliko yote yanarekodiwa.",
      "Financial Parameters": "Vigezo vya Kifedha",
      "Interest applies to loans; OF applies to any deposit; penalties are posted daily at 19:01.": "Riba inatumika kwa mikopo; SSC inatumika tu kwa miamala ya amana; adhabu zinatumwa kila siku saa 19:01.",
      "Interest applies to loans; SSC applies only to deposit transactions; penalties are posted daily at 19:01.": "Riba inatumika kwa mikopo; SSC inatumika tu kwa miamala ya amana; adhabu zinatumwa kila siku saa 19:01.",
      "Interest Rate (%)": "Kiwango cha Riba (%)",
      "Operation Fee (OF %)": "Tozo ya Huduma ya Mfumo (SSC %)",
      "System Service Charge (SSC %)": "Tozo ya Huduma ya Mfumo (SSC %)",
      "Applies globally to all contributions.": "Inatumika kwa miamala ya amana pekee. Chaguomsingi ni 10%.",
      "Applies globally to deposit transactions only. Default is 10%.": "Inatumika kwa miamala ya amana pekee. Chaguomsingi ni 10%.",
      "Managed centrally by the system administrator.": "Inasimamiwa na msimamizi wa mfumo. Chaguomsingi ni 10%.",
      "Managed centrally by the system administrator. Default is 10%.": "Inasimamiwa na msimamizi wa mfumo. Chaguomsingi ni 10%.",
      "Bank Charge (%)": "Tozo la Benki (%)",
      "Percent deducted from dividend pools for bank / processing charges.": "Asilimia inayokatwa kwenye mabwawa ya mgao kwa ajili ya tozo za benki / usindikaji.",
      "Retention Percent (%)": "Asilimia ya Kiasi Kinachozuiliwa (%)",
      "Percent retained when members withdraw.": "Asilimia inayozuiliwa mwanachama anapojiondoa.",
      "Managed centrally by the platform admin.": "Inasimamiwa na admin wa jukwaa.",
      "Required Deposit (%)": "Amana Inayohitajika (%)",
      "Minimum savings percentage before a member can borrow.": "Kiwango cha chini cha akiba kabla mwanachama hajakopa.",
      "Penalty Amount (TZS)": "Kiasi cha Adhabu (TZS)",
      "Applied uniformly regardless of repayment schedule.": "Inatumika sawa bila kujali ratiba ya malipo.",
      "Penalty Execution Time": "Muda wa Adhabu",
      "Daily cutoff for applying late penalties (24h).": "Muda wa mwisho wa kutuma adhabu za kuchelewa (saa 24).",
      "Auto-deactivate members in arrears": "Zima wanachama wenye madeni kiotomatiki",
      "Entry Fee Amount": "Kiasi cha Kiingilio",
      "One-time fee per member when joining.": "Ada ya mara moja kwa mwanachama anapojiunga.",
      "Statement Fee Per Page": "Ada ya Taarifa kwa Ukurasa",
      "System Registration Fee (SRF)": "Ada ya Usajili wa Mfumo (SRF)",
      "System Annual Fee (SAF)": "Ada ya Mwaka ya Mfumo (SAF)",
      "SAF Payment Deadline": "Mwisho wa Malipo wa SAF",
      "SAF Deadline Month": "Mwezi wa Mwisho wa SAF",
      "SAF Deadline Day": "Siku ya Mwisho ya SAF",
      "Applies to newly created members only. Default is 5,000 TZS.": "Inatumika kwa wanachama wapya pekee. Chaguomsingi ni TZS 5,000.",
      "Yearly access fee. Default is 10,000 TZS.": "Ada ya upatikanaji ya kila mwaka. Chaguomsingi ni TZS 10,000.",
      "Calendar month used for the annual SAF deadline.": "Mwezi wa kalenda unaotumika kwa mwisho wa SAF wa kila mwaka.",
      "Calendar day used for the annual SAF deadline.": "Siku ya kalenda inayotumika kwa mwisho wa SAF wa kila mwaka.",
      "Invalid SRF Amount": "Kiasi cha SRF si sahihi",
      "System Registration Fee cannot be negative.": "Ada ya Usajili wa Mfumo haiwezi kuwa hasi.",
      "Invalid SAF Amount": "Kiasi cha SAF si sahihi",
      "System Annual Fee cannot be negative.": "Ada ya Mwaka ya Mfumo haiwezi kuwa hasi.",
      "Invalid SAF Deadline Month": "Mwezi wa mwisho wa SAF si sahihi",
      "SAF deadline month must be between 1 and 12.": "Mwezi wa mwisho wa SAF lazima uwe kati ya 1 na 12.",
      "Invalid SAF Deadline Day": "Siku ya mwisho ya SAF si sahihi",
      "SAF deadline day must be between 1 and 31.": "Siku ya mwisho ya SAF lazima iwe kati ya 1 na 31.",
      "Billable fee per page when downloading member statements.": "Ada inayotozwa kwa ukurasa wakati wa kupakua taarifa za wanachama.",
      "Default Repayment Method": "Njia Mbadala ya Malipo",
      "Daily": "Kila Siku",
      "Weekly": "Kila Wiki",
      "Monthly": "Kila Mwezi",
      "Restrict Sunday transactions (create/repayment not allowed)": "Zuia miamala ya Jumapili (kuunda/kulipa hakuruhusiwi)",
      "Save Settings": "Hifadhi Mipangilio",
      "Saving...": "Inahifadhi...",
      "Reset to Defaults": "Rejesha Mipangilio ya Awali",
      "Configuration Audit Trail": "Kumbukumbu ya Ukaguzi wa Mipangilio",
      "No audit entries yet.": "Hakuna kumbukumbu za ukaguzi bado.",
      "Unsaved changes": "Mabadiliko yasiyohifadhiwa",
      "Up to date": "Imesasishwa",
      "Failed to load settings": "Imeshindwa kupakia mipangilio",
      "Invalid Interest Rate": "Riba Batili",
      "Interest must be between 0% and 100%.": "Riba lazima iwe kati ya 0% na 100%.",
      "Invalid DF%": "SSC% Batili",
      "Invalid SSC%": "SSC% Batili",
      "DF must be between 0% and 100%.": "SSC lazima iwe kati ya 0% na 100%.",
      "SSC must be between 0% and 100%.": "SSC lazima iwe kati ya 0% na 100%.",
      "Invalid Penalty": "Adhabu Batili",
      "Penalty amounts cannot be negative.": "Kiasi cha adhabu hakiwezi kuwa hasi.",
      "Invalid Retention %": "Asilimia ya Zuio Batili",
      "Retention must be between 0% and 100%.": "Zuio lazima liwe kati ya 0% na 100%.",
      "Invalid Required Deposit %": "Amana Inayohitajika Batili",
      "Required deposit must be between 0% and 100%.": "Amana inayohitajika lazima iwe kati ya 0% na 100%.",
      "Invalid Bank Charge %": "Tozo la Benki Batili",
      "Bank charge must be between 0% and 100%.": "Tozo la benki lazima liwe kati ya 0% na 100%.",
      "Settings Saved": "Mipangilio Imehifadhiwa",
      "Save failed": "Hifadhi imeshindwa",
      "Reset to Defaults?": "Rejesha kwa Mipangilio ya Awali?",
      "This will revert settings and permissions to default recommendations.": "Hii itarejesha mipangilio na ruhusa kwa mapendekezo ya awali.",
      "Reset": "Rejesha",
      "Reset Complete": "Urejesho Umekamilika",
      "Loading system settings...": "Inapakia mipangilio ya mfumo...",
      "Group System Settings": "Mipangilio ya Mfumo wa Kikundi",
      "These settings affect only your group.": "Mipangilio hii inaathiri kikundi chako tu.",
      "Platform System Settings": "Mipangilio ya Mfumo wa Jukwaa",
      "Manage platform-wide defaults. Only operation fee is configurable at this level.": "Simamia mipangilio ya jukwaa zima. Tozo ya Huduma ya Mfumo (SSC) pekee ndiyo inayoweza kusanidiwa katika kiwango hiki.",
      "Manage platform-wide defaults. Only System Service Charge (SSC) is configurable at this level.": "Simamia mipangilio ya jukwaa zima. Tozo ya Huduma ya Mfumo (SSC) pekee ndiyo inayoweza kusanidiwa katika kiwango hiki.",
      "Contribute according to your group terms ({{frequency}}). Each deposit includes a {{percent}}% System Service Charge (SSC).": "Changia kulingana na masharti ya kikundi chako ({{frequency}}). Kila amana ina Tozo ya Huduma ya Mfumo (SSC) ya {{percent}}%.",
      "SSC: {{amount}}": "SSC: {{amount}}",
      "Charge: {{amount}}": "Tozo: {{amount}}",
      "Outstanding SSC (optional)": "SSC iliyobaki (si lazima)",
      "Outstanding charge (optional)": "Tozo iliyobaki (si lazima)",

      common: {
        changeLanguage: "Badilisha lugha",
        english: "Kiingereza",
        swahili: "Kiswahili",
      },
      login: {
        heroLabel: "Savvy Community",
        heroHeadline: "Zana za kiwango cha benki kwa Savvy Community za kisasa",
        heroBody:
          "Dhibiti michango, adhabu, mikopo na taarifa kwa wakati halisi kwa uwazi unaojenga imani ya wanachama.",
        heroPoints: [
          "Dashibodi za wakati halisi",
          "Kumbukumbu za uzingatiaji kiotomatiki",
          "Taarifa rafiki kwa wanachama",
        ],
        greeting: "Karibu tena Savvy Community",
        subtitle: "Ingia ili kuendeleza mwenendo wa kifedha wa kundi lako.",
      },
      layout: {
        notificationsTitle: "Taarifa",
        noNotifications: "Hakuna taarifa mpya",
        adminSection: "Utawala",
        workflowsSection: "Mitiririko ya kazi",
        coreSection: "Kiini",
        reportsSection: "Ripoti",
        profile: "Akaunti Yangu",
        logout: "Ondoka",
        systemName: "Savvy Community",
        groupLabel: "Kikundi",
        noGroup: "Hakuna kikundi",
      },
      nav: {
        adminDashboard: "Dashibodi ya Msimamizi",
        userManagementAdmin: "Usimamizi wa Watumiaji (Utawala)",
        settings: "Mipangilio",
        chairpersonSettings: "Mipangilio ya Kundi",
        deskOfficerDashboard: "Dashibodi ya Afisa wa Dawati",
        chairpersonDashboard: "Dashibodi ya Mwenyekiti",
        katibuDashboard: "Dashibodi ya Katibu",
        accountantDashboard: "Dashibodi ya Mhasibu",
        memberDashboard: "Dashibodi ya Mwanachama",
        loans: "Mikopo",
        groupsDeskOfficer: "Vikundi (Afisa wa Dawati)",
        membersChairperson: "Wanachama (Mwenyekiti)",
        contributionsMember: "Michango (Mwanachama)",
        catchupPayments: "Malipo Yangu ya Kufidia",
        catchupPaymentsChair: "Simamia Malipo ya Kufidia",
        emergencyChair: "Michango ya Dharura (Mwenyekiti)",
        emergencyMember: "Michango ya Dharura (Mwanachama)",
        groupBusinessesChair: "Biashara za Kundi (Mwenyekiti)",
        groupBusinessesAdmin: "Biashara za Kundi (Utawala)",
        specialContributionsMember: "Michango Maalum (Mwanachama)",
        dividendsMember: "Mgao (Mwanachama)",
        dividendsChair: "Mgao (Mwenyekiti)",
        financeTransactions: "Shughuli za Fedha",
        upatuDisbursements: "Upatu - Utoaji Fedha",
        memberWithdrawalApprovals: "Idhini za Kujiondoa",
        switchGroup: "Badilisha Kikundi",
        loanReport: "Ripoti ya Mkopo",
        repayments: "Malipo ya Mikopo",
        generalReport: "Ripoti ya Jumla",
        monthlyGroupPerformance: "Utendaji wa Kundi wa Kila Mwezi",
        memberHealthScore: "Afya ya Kifedha ya Mwanachama",
        groupLiquidity: "Uwezo wa Kiasi cha Kikundi",
        systemGrowthMetrics: "Vigezo vya Ukuaji wa Mfumo",
        auditCompliance: "Ukaguzi na Uzingatiaji",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "sw"],
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
